<template>
  <div class="assignments-revamp assignments-revamp--modern oms-list-page oms-list-page--assignments oms-list-page--compact-table">
    <loading :active.sync="loading" />
    <v-card class="assignments-panel oms-list-panel">
      <section class="assignments-nav-grid oms-list-nav">
        <SegmentedControl
          class="main__tabs assignments-primary-tabs"
          aria-label="Assignment module view"
          :value="tabStatusMain"
          :options="[
            { label: 'Job View', value: 'Jobs', icon: 'work_outline' },
            {
              label: 'Assignment View',
              value: 'Assignment',
              icon: 'assignment',
            },
          ]"
          @change="redirectTo"
        />

        <SegmentedControl
          class="assignments-status-tabs"
          aria-label="Assignment status"
          :value="tabStatus"
          :options="[
            {
              label: 'Unassigned Assignments',
              value: 'Unassigned',
              badge: newUnassigned,
            },
            {
              label: 'In Progress Assignments',
              value: 'In-progress',
              badge: newInprogress,
            },
            {
              label: 'Completed Assignments',
              value: 'Completed',
              badge: newCompleted,
            },
          ]"
          @change="searchData($event, null)"
        />
      </section>

      <section class="assignments-stats-grid oms-list-stats">
        <article class="assignments-stat-card assignments-stat-card--active oms-list-stat-card">
          <div class="assignments-stat-icon"><v-icon>assignment</v-icon></div>
          <span>Unassigned</span>
          <strong>{{ newUnassigned || 0 }}</strong>
          <small>Open queue</small>
        </article>
        <article class="assignments-stat-card assignments-stat-card--moving oms-list-stat-card">
          <div class="assignments-stat-icon"><v-icon>timeline</v-icon></div>
          <span>In Progress</span>
          <strong>{{ newInprogress || 0 }}</strong>
          <small>Live movement</small>
        </article>
        <article class="assignments-stat-card assignments-stat-card--done oms-list-stat-card">
          <div class="assignments-stat-icon"><v-icon>check_circle</v-icon></div>
          <span>Completed</span>
          <strong>{{ newCompleted || 0 }}</strong>
          <small>Closed records</small>
        </article>
        <article class="assignments-stat-card assignments-stat-card--total oms-list-stat-card">
          <div class="assignments-stat-icon"><v-icon>dashboard</v-icon></div>
          <span>Total Results</span>
          <strong>{{ totalJob || 0 }}</strong>
          <small>Current view</small>
        </article>
      </section>

      <v-card-title class="bg-clr assignments-legacy-spacer"> </v-card-title>

      <FilterBoard
        class="assignments-filter-panel oms-list-filter"
        :title="`${tabStatus} assignment queue`"
      >
          <v-flex
            xs2
            class="oms-filter-board__field oms-filter-board__field--tight"
          >
            <v-autocomplete
              v-model="searchTypes"
              :items="searchItems"
              label="Search by"
              item-text="status"
              single-line
              item-value="abbr"
              persistent-hint
              @change="searchData()"
              return-object
            ></v-autocomplete>
          </v-flex>
          <v-divider class="divider-style" vertical></v-divider>
          <v-flex xs2 md3 pr-1 class="oms-filter-board__field oms-filter-board__field--search">
            <v-text-field
              class="gap searchAccounts"
              label="Search ID or company..."
              :disabled="!searchTypes"
              single-line
              v-model="search"
              @keyup.enter="searchData()"
              @click:append="searchData()"
              append-icon="search"
            ></v-text-field>
          </v-flex>
          <v-flex
            xs2
            class="oms-filter-board__field oms-filter-board__field--tight"
          >
            <v-autocomplete
              v-model="driverSearchTypes"
              :items="driverSearchItems"
              label="Refine by"
              item-text="status"
              single-line
              item-value="abbr"
              persistent-hint
              @change="searchData()"
              return-object
            ></v-autocomplete>
          </v-flex>
          <v-divider class="divider-style" vertical></v-divider>
          <v-flex xs2 md3 pr-3 class="oms-filter-board__field oms-filter-board__field--search">
            <v-text-field
              class="gap searchAccounts"
              label="Refine results..."
              :disabled="!driverSearchTypes"
              single-line
              v-model="driverSearch"
              @keyup.enter="searchData()"
              @click:append="searchData()"
              append-icon="search"
            ></v-text-field>
          </v-flex>

          <v-flex
            xs2
            pr-2
            class="oms-filter-board__field"
            v-if="this.tabStatus != 'Unassigned'"
          >
            <v-autocomplete
              label="Assign Status"
              :items="statusList"
              class="pt-0"
              v-model="assignStatus"
              @change="searchData()"
              item-text="text"
              item-value="value"
              single-line
            />
          </v-flex>
          <v-flex
            xs2
            pr-2
            class="oms-filter-board__field"
            v-if="this.tabStatus != 'Unassigned'"
          >
            <v-autocomplete
              label="Adv. Status"
              :items="advanceStatusList"
              class="pt-0"
              v-model="advanceStatus"
              @change="searchData()"
              item-text="text"
              item-value="value"
              single-line
            />
          </v-flex>

          <v-flex
            xs4
            pt-3
            pr-3
            pl-1
            id="jobDate"
            class="wrapper date_9 oms-filter-board__field oms-filter-board__field--date"
          >
            <ejs-daterangepicker
              :placeholder="waterMark"
              v-model="dateRange2"
            ></ejs-daterangepicker>
          </v-flex>
          <v-flex xs1 class="reset-btn oms-filter-board__actions">
            <v-card-actions class="justify-center">
              <v-btn
                flat
                class="reset-btn-color oms-filter-board__reset oms-btn oms-btn--secondary"
                prepend-icon
                color="orange darken-1"
                @click.native="reset()"
              >
                Reset
              </v-btn>
            </v-card-actions>
          </v-flex>
          <v-flex xs1 pl-3 class="reset-btn oms-filter-board__actions">
            <v-card-actions class="justify-center">
              <v-btn
                flat
                class="reset-btn-color mx-2 oms-filter-board__reset oms-btn oms-btn--secondary"
                prepend-icon
                color="orange darken-1"
                @click="filter_toggle()"
              >
                <v-icon color="orange">filter_alt</v-icon>
                More filters
              </v-btn>
            </v-card-actions>
          </v-flex>
      </FilterBoard>
      <FilterBoard
        id="filter-toggle"
        class="assignments-filter-panel assignments-filter-panel--advanced oms-list-filter"
        :show-heading="false"
      >
          <v-flex xs2 pr-2 pt-0 class="oms-filter-board__field">
            <v-select
              v-model="subJobType"
              :items="JobTypes"
              label="Job Type"
              persistent-hint
              return-object
              @change="searchData()"
              single-line
            ></v-select>
          </v-flex>

          <v-flex
            xs2
            pr-2
            pt-0
            class="oms-filter-board__field"
            v-if="subJobType.value === 'landFreight'"
          >
            <v-autocomplete
              label="Truck Type"
              :items="subTruck"
              class="pt-0"
              v-model="subTruckType"
              @change="searchData()"
              item-text="text"
              item-value="value"
              single-line
            />
          </v-flex>
      </FilterBoard>
      <v-card-text class="nospace assignments-table-card oms-list-table-card">
        <ScrollableTable
          class="assignments-table-scroll oms-list-table-scroll"
          min-width="100%"
        >
          <v-data-table
            id="jobsTable"
            class="assignments-table oms-list-table"
            hide-actions
            :headers="headers"
            :disable-initial-sort="false"
            :items="items"
          >
          <template slot="items" slot-scope="props">
            <td class="assignments-job-td" style="position: relative">
              <v-layout row>
                <v-flex
                  xs12
                  md3
                  class="blink__icon"
                  v-if="
                    !props.item.isAcknowedged &&
                    props.item.assignmentStatus != -1
                  "
                >
                  <v-tooltip
                    right
                    class="milestone"
                    content-class="tooltip-op"
                    color="orange"
                  >
                    <template slot="activator">
                      <svg
                        aria-hidden="true"
                        class="assignments-attention-icon"
                        focusable="false"
                        viewBox="0 0 60 60"
                      >
                        <circle
                          fill="#FF0000"
                          stroke="none"
                          cx="30"
                          cy="30"
                          r="6"
                        >
                          <animate
                            attributeName="opacity"
                            dur="1s"
                            values="0;1;0"
                            repeatCount="indefinite"
                            begin="0.1"
                          />
                        </circle>
                      </svg>
                    </template>

                    <span class="tooltip" v-if="activeMenu == 13"
                      >Please acknowledge the job from the job view to assign
                      driver to the assignment and proceed further.
                    </span>
                    <span class="tooltip" v-else
                      >Please acknowledge the job from the Procurement's job
                      view to assign driver to the assignment and proceed
                      further.
                    </span>
                  </v-tooltip>
                </v-flex>
                <activityLogs
                  :type="'assignment'"
                  :permissions="'activity-logs-jobs'"
                  :_id="props.item._id"
                  :id="props.item.assignmentId.toString()"
                />

              <span
                class="assignments-job-id"
                :title="props.item.jobId.toString()"
              >
                {{ props.item.jobId }}
              </span>
              </v-layout>
              <div class="assignments-date-line">
                {{ getTime3(props.item.pickupDate) }}
                {{ props.item.pickupTime }}
              </div>
            </td>
            <td>
              <div class="assignments-assignment-cell">
                <span
                  class="assignments-id-value assignments-id-value--vas"
                  v-if="props.item.assignmentType == 'Value Added Service'"
                  :title="props.item.assignmentId.toString()"
                >
                  {{ props.item.assignmentId }}</span
                >
                <span
                  class="assignments-id-value"
                  :title="props.item.assignmentId.toString()"
                  v-else
                >
                  {{ props.item.assignmentId }}</span
                >
                <span
                  class="assignments-status-pill"
                  :class="{
                    'assignments-status-pill--cancelled':
                      props.item.assignmentStatus === -1,
                    'assignments-status-pill--open':
                      props.item.assignmentStatus === 0 ||
                      props.item.assignmentStatus === 1,
                    'assignments-status-pill--moving':
                      props.item.assignmentStatus === 2 ||
                      props.item.assignmentStatus === 5 ||
                      props.item.assignmentStatus === 6,
                    'assignments-status-pill--pending':
                      props.item.assignmentStatus === 3 ||
                      props.item.assignmentStatus === 8,
                    'assignments-status-pill--done':
                      props.item.assignmentStatus === 4 ||
                      props.item.assignmentStatus === 7
                  }"
                >
                  {{ assignmentStatus(props.item.assignmentStatus) || "-" }}
                </span>
              </div>
            </td>
            <td>
              <div class="assignments-customer-cell">
                <span>{{ props.item.companyName || "N.A" }}</span>
                <span
                  v-if="props.item.customerPhoneNumber"
                  class="assignments-customer-cell__phone"
                  >{{
                    props.item.customerCountryCode
                      ? props.item.customerCountryCode +
                        "-" +
                        props.item.customerPhoneNumber.replace(
                          props.item.customerCountryCode,
                          ""
                        )
                      : props.item.customerPhoneNumber
                  }}</span
                >
                <CustomerDetailPopUp :detail="props.item" />
              </div>
            </td>
            <td>
              <span v-if="props.item.driverData">
                {{
                  props.item.driverData.firstName +
                  " " +
                  props.item.driverData.lastName
                }}<br />{{
                  props.item.driverData.countryCode +
                  "-" +
                  props.item.driverData.phoneNo
                }}</span
              >
              <span
                v-if="
                  (!props.item.driverData &&
                    props.item.assignmentStatus === -1) ||
                  !props.item.isAcknowedged
                "
                >N.A</span
              >

              <ViewDetails
                v-if="props.item.driverData"
                :detail="props.item.driverData"
                :headers="driverDetailHeaders"
                :title="'Driver'"
              />
              <div
                v-if="
                  !props.item.hasVasAttached &&
                  props.item.assignmentType == 'Normal'
                "
              >
                <button
                  type="button"
                  class="track-ass-btn red-button mt-2 oms-btn oms-btn--destructive"
                  v-permissions="'unassign-driver-jobs'"
                  v-if="
                    (!props.item.isGenerated &&
                      props.item.assignmentStatus === 2 &&
                      props.item.totalAdditionalAmount == 0) ||
                    (props.item.assignmentStatus === 5 &&
                      props.item.totalAdditionalAmount == 0 &&
                      !props.item.isGenerated)
                  "
                  @click="openDriverUnassign(props.item)"
                >
                  Unassign
                </button>
              </div>
              <span
                v-if="
                  props.item.finalPaymentWithCreditDaysDriver &&
                  props.item.assignmentStatus != 4
                "
                class="font_Bold"
              >
                <span
                  v-if="
                    getDays(props.item.finalPaymentWithCreditDaysDriver) > 5
                  "
                  class="orange-text"
                >
                  Credit Days:
                  {{ getDays(props.item.finalPaymentWithCreditDaysDriver) }}
                </span>
                <span v-else class="red-text">
                  Credit Days:
                  {{ getDays(props.item.finalPaymentWithCreditDaysDriver) }}
                </span>
              </span>

              <JobsProfileDriverAssign
                v-if="
                  props.item.isAcknowedged &&
                  props.item.jobType == 1 &&
                  !props.item.isGenerated &&
                  props.item.assignmentStatus === 1
                "
                :milestoneId="props.item.milestoneId"
                :assignmentId="props.item.assignmentId"
                :assignmentDetail="props.item"
                :jobStatus="props.item.jobStatus"
                @transporter-success="refresh()"
                :currency="props.item.customerCurrency"
                :country="props.item.workingCountry"
                @refresh-assign-list="refresh()"
                :type="2"
              />
              <jobProfileDriverAssignAir
                v-if="props.item.isAcknowedged && props.item.jobType == 2"
                :milestoneId="props.item.milestoneId"
                :assignmentDetail="props.item"
                :jobStatus="props.item.jobStatus"
                :assignmentId="props.item.assignmentId"
                :country="props.item.workingCountry"
                :currency="props.item.customerCurrency"
                :type="2"
                @refresh-assign-list="refresh()"
              />
              <jobProfileDriverAssignSea
                v-if="props.item.isAcknowedged && props.item.jobType == 3"
                :assignmentDetail="props.item"
                :jobStatus="props.item.jobStatus"
                :milestoneId="props.item.milestoneId"
                :currency="props.item.customerCurrency"
                :country="props.item.workingCountry"
                :assignmentId="props.item.assignmentId"
                :type="2"
                @refresh-assign-list="refresh()"
              />
            </td>
            <td>
              <div v-if="props.item.transporterData">
                {{ props.item.transporterData.transporterName || "-" }}<br />{{
                  props.item.transporterData.countryCode +
                  "-" +
                  props.item.transporterData.phoneNo
                }}
              </div>
              <div v-else>N.A</div>
              <ViewDetails
                v-if="props.item.transporterData"
                :detail="props.item.transporterData"
                :headers="transporterDetailHeaders"
                :title="'Transporter'"
              />
              <v-flex>
                <div
                  v-if="
                    !props.item.hasVasAttached &&
                    props.item.assignmentType == 'Normal'
                  "
                >
                  <button
                    type="button"
                    class="track-ass-btn red-button mt-2 oms-btn oms-btn--destructive"
                    v-permissions="'unassign-driver-jobs'"
                    v-if="
                      props.item.assignedToTransporter &&
                      !props.item.isGenerated &&
                      ((props.item.totalAdditionalAmount == 0 &&
                        props.item.assignmentStatus === 1) ||
                        (props.item.totalAdditionalAmount == 0 &&
                          props.item.assignmentStatus === 2) ||
                        (props.item.totalAdditionalAmount == 0 &&
                          props.item.assignmentStatus === 5))
                    "
                    :disabled="props.item.jobStatus === 10"
                    @click="openTransporterUnassign(props.item)"
                  >
                    Unassign
                  </button>
                </div>
              </v-flex>
            </td>
            <td>
              <v-flex v-if="props.item.driverData">
                <v-tooltip
                  right
                  class="milestone"
                  content-class="tooltip-op"
                  color="orange"
                >
                  <template slot="activator" v-if="props.item.truckNumber">
                    {{ props.item.truckPrefix }}-{{
                      props.item.truckNumber
                    }}</template
                  >
                  <template slot="activator" v-else>
                    {{ props.item.driverData.truckPrefix }}-{{
                      props.item.driverData.truckNumber
                    }}</template
                  >
                  <span class="tooltip" v-if="props.item.jobType === '1'"
                    >{{ getText(TruckTypesList, props.item.truckType) }}
                  </span>

                  <span class="tooltip" v-if="props.item.jobType === '2'">
                    {{
                      getText(airTypes, props.item.truckType.toString())
                    }}</span
                  >
                  <span class="tooltip" v-if="props.item.jobType === '3'">
                    {{
                      getText(seaTypes, props.item.truckType.toString())
                    }}</span
                  >
                </v-tooltip>
              </v-flex>

              <v-flex v-else> N.A </v-flex>
            </td>
            <td v-if="props.item.paymentAmount">
              {{ props.item.paymentAmount }} {{ props.item.customerCurrency }}
            </td>
            <td v-else>N.A</td>
            <td v-if="props.item.jobData.isJobActivatedByScript">N.A</td>
            <td v-else>
              <v-layout row justify-center>
                <activityLogs
                  :permissions="'activity-logs-for-accounts'"
                  class="pd_5"
                  :type="'jobs'"
                  v-if="
                    props.item.advanceAmount || props.item.everAdvanceGenerated
                  "
                  :subType="5"
                  :assignmentId="props.item._id"
                  :whichId="'Assignment'"
                  :_id="props.item.jobData._id"
                  :id="props.item.assignmentId.toString()"
                  :section="'advance'"
                />

                <span class="pd-t-l" v-if="props.item.advanceAmount"
                  >{{ props.item.advanceAmount }}
                  {{ props.item.customerCurrency }}</span
                >
              </v-layout>
              <!-- {{ props.item.driverData.ownerType.toString() }}
              {{
                props.item.driverData.ownerType
                  .toString()
                  .includes("Transporter")
              }} -->
              <GenerateAdvance
                :assId="props.item.assignmentId"
                v-permissions="'generate-advance-jobs'"
                :status="props.item.assignmentStatus"
                :currency="props.item.customerCurrency"
                :additionalCharges="props.item.totalAdditionalAmount"
                :type="'1'"
                :driverCreditDuration="
                  props.item.driverData
                    ? props.item.driverData.driverPaymentDuration
                    : null
                "
                :assignedToTransporter="props.item.assignedToTransporter"
                :ownerType="props.item.ownerType"
                :invoiceCity="props.item.invoicingCity"
                :invoiceCompany="props.item.invoicingCountry"
                :totaladvancePaid="props.item.totalAdvancePaidAmount"
                :maximumAdvanceLeftAmount="props.item.maximumAdvanceLeftAmount"
                @generateAdvance="refresh()"
                @assignment-list-refresh="refresh()"
                :totalAmount="props.item.paymentAmount"
                :totalAdvanceAmount="props.item.advanceAmount"
              />

              <generateAdvancePopup
                v-if="props.item.assignmentStatus > 1"
                :assignId="props.item._id"
                :advancePaid="props.item.totalAdvancePaidAmount"
                :jobCurrency="props.item.customerCurrency"
                :additionalCharges="props.item.totalAdditionalAmount"
                :status="props.item.assignmentStatus"
                @assignment-list-refresh="refresh()"
              />
              <span
                v-if="
                  props.item.assignmentStatus <= 1 && !props.item.advanceAmount
                "
                >N.A</span
              >
            </td>
            <td>
              <span v-if="props.item.totalAdvancePaidAmount"
                >{{ props.item.totalAdvancePaidAmount }}
                {{ props.item.customerCurrency }}</span
              >
              <span v-else>N.A</span>
            </td>
            <td v-if="props.item.jobData.isJobActivatedByScript">N.A</td>
            <td v-else>
              <span v-if="props.item.totalMiscellaneousChargeAmount">
                Misc:&nbsp;{{ props.item.totalMiscellaneousChargeAmount }}
                {{ props.item.customerCurrency }}</span
              >
              <br v-if="props.item.totalAdditionalAmount" />
              <span v-if="props.item.totalAdditionalAmount">
                Driver:&nbsp;{{ props.item.totalAdditionalAmount }}
                {{ props.item.customerCurrency }}</span
              ><br v-if="props.item.totalCostMarginAdditionalAmount" />
              <span v-if="props.item.totalCostMarginAdditionalAmount">
                Customer:&nbsp;{{ props.item.totalCostMarginAdditionalAmount }}
                {{ props.item.customerCurrency }}</span
              >
              <additionalChargesPopup
                v-if="props.item.assignmentStatus > 1"
                :isAssign="props.item._id"
                :jobCurrency="props.item.customerCurrency"
                :jobSalesInvoice="props.item.jobData.isSalesInvoiceGenerated"
                :amountPaidToDriver="props.item.amountPaidToDriver"
                :assignSalesInvoice="props.item.isSalesInvoiceGenerated"
                :isCustomerReceiptInitiate="
                  props.item.isCustomerReceiptInitiated
                "
                @assignment-list-refresh="refresh()"
              />
              <span v-if="props.item.assignmentStatus <= 1">N.A</span>
            </td>
            <td class="assignments-final-payment-cell">
              <v-layout justify-center>
                <v-flex xs3 v-if="props.item.isReadyForFinalPayment">
                  <activityLogs
                    v-if="props.item.isReadyForFinalPayment"
                    class="pd_5"
                    :permissions="'activity-logs-for-accounts'"
                    :type="'assignment'"
                    :subType="7"
                    :assignmentId="props.item._id"
                    :_id="props.item.jobData._id"
                    :whichId="'Assignment'"
                    :id="props.item.assignmentId.toString()"
                    :section="'advance'"
                  />
                </v-flex>
                <span
                  class="pd_8"
                  v-if="
                    !props.item.isPurchaseInvoiceGenerated &&
                    props.item.workingCountry === 'PAK' &&
                    props.item.assignmentStatus >= 3 &&
                    props.item.assignmentStatus != -1 &&
                    props.item.assignmentStatus != 4 &&
                    props.item.assignmentStatus != 7
                  "
                >
                  {{ getAdvanceAmount(props.item) }}</span
                >
                <span
                  class="pd_8"
                  v-else-if="
                    props.item.isPurchaseInvoiceGenerated &&
                    props.item.assignmentStatus >= 2 &&
                    props.item.assignmentStatus != -1 &&
                    props.item.assignmentStatus != 7 &&
                    props.item.assignmentStatus != 4
                  "
                >
                  {{ getAdvanceAmount(props.item) }}
                </span>

                <!-- <span
                  class="pd_8"
                  v-if="
                    props.item.isPurchaseInvoiceGenerated &&
                    props.item.assignmentStatus >= 2 &&
                    props.item.assignmentStatus != -1 &&
                    props.item.assignmentStatus != 4 &&
                    props.item.amountPaidToDriver
                  "
                >
                  {{
                    props.item.paymentAmount -
                      props.item.totalAdvancePaidAmount -
                      props.item.amountPaidToDriver +
                      props.item.totalAdditionalAmount ==
                    0
                      ? " "
                      : props.item.paymentAmount -
                        props.item.totalAdvancePaidAmount -
                        props.item.amountPaidToDriver +
                        props.item.totalAdditionalAmount
                  }}
                  {{
                    props.item.paymentAmount -
                      props.item.totalAdvancePaidAmount -
                      props.item.amountPaidToDriver +
                      props.item.totalAdditionalAmount ==
                    0
                      ? ""
                      : props.item.customerCurrency
                  }}</span
                >

                <span
                  class="pd_8"
                  v-else-if="
                    props.item.isPurchaseInvoiceGenerated &&
                    props.item.assignmentStatus >= 2 &&
                    props.item.assignmentStatus != -1 &&
                    props.item.assignmentStatus != 4
                  "
                >
                  {{
                    props.item.paymentAmount -
                      props.item.totalAdvancePaidAmount +
                      props.item.totalAdditionalAmount ==
                    0
                      ? " "
                      : props.item.paymentAmount -
                        props.item.totalAdvancePaidAmount +
                        props.item.totalAdditionalAmount
                  }}
                  {{
                    props.item.paymentAmount -
                      props.item.totalAdvancePaidAmount +
                      props.item.totalAdditionalAmount ==
                    0
                      ? ""
                      : props.item.customerCurrency
                  }}</span
                > -->
              </v-layout>
              <v-layout class="assignments-ready-doc-row">
                <AddPhysicalDoc
                  :assignDetails="props.item"
                  :section="'assignmentList'"
                  :driverCreditDuration="
                    props.item.driverData
                      ? props.item.driverData.driverPaymentDuration
                      : null
                  "
                  @ready-to-pay="refresh()"
                />
              </v-layout>
              <v-layout
                class="assignments-ready-doc-row pb-1 pt-1"
                align-center
                justify-center
              >
                <EditPhysicalDoc
                  v-if="!props.item.amountPaidToDriver"
                  :assignDetails="props.item"
                  :section="'assignmentList'"
                  :driverCreditDuration="
                    props.item.driverData
                      ? props.item.driverData.driverPaymentDuration
                      : null
                  "
                  @ready-to-pay="refresh()"
                />

                <PaymentDone
                  :section="'Assignment'"
                  :confirmationTitle="'Comments'"
                  :details="props.item"
                  :cancelBtn="'Cancel'"
                  @close="error = 'Kindly collect the gps device'"
                  :PendingAmount="getPendingAmountForProps(props.item)"
                  :assignId="props.item._id"
                  :confirmBtn="'Pay'"
                  @refresh-list="refresh()"
                />
                <v-flex
                  v-if="
                    props.item.assignmentStatus != 4 &&
                    props.item.assignmentStatus == 3 &&
                    getPendingAmountForProps(props.item) > 0 &&
                    props.item.amountPaidToDriver
                  "
                  style="padding-right: 10px !important"
                >
                  <PendingAmountList
                    :type="'PO'"
                    :PendingAmount="getPendingAmountForProps(props.item)"
                    :assignId="props.item._id"
                    :currency="props.item.customerCurrency"
                    @assignment-list-refresh="refresh()"
                  />
                </v-flex>
              </v-layout>
              <button
                v-if="props.item.isReadyForFinalPayment"
                class="track-assign-btn blue-button oms-btn oms-btn--secondary"
                flat
                prepend-icon
                color="white darken-1"
                @click.stop="goToProof(props.item._id)"
              >
                View Docs
              </button>
              <span
                v-if="
                  !getAdvanceAmount(props.item) &&
                  props.item.assignmentStatus !== 3 &&
                  props.item.assignmentStatus !== 6 &&
                  props.item.assignmentStatus !== 4 &&
                  props.item.assignmentStatus !== 7
                "
              >
                N.A
              </span>
            </td>
            <td class="assignments-comment-cell">
              <CommentCell
                v-if="props.item.isAcknowedged"
                :comment="
                  props.item.LastCommentTime &&
                  props.item.LastCommentTime.comment
                "
              >
                <template slot="action">
                <SendComments
                  class="oms-comment-cell__action assignments-comment-action"
                  v-if="props.item.isAcknowedged"
                  compact-action
                  :userId="props.item.userId"
                  :userName="props.item.customer"
                  :detail="props.item"
                  :type="3"
                  :assignId="props.item._id"
                  v-on:pagination-load="refreshOnComment"
                  :section="'assignments'"
                  :id="props.item.jobId"
                />
                </template>
              </CommentCell>
              <CommentCell v-else />
            </td>

            <td>
              <v-layout justify-center>
                <generateAdvancePopup
                  v-if="
                    props.item.assignmentStatus > 1 &&
                    props.item.assignmentStatus != 4
                  "
                  :assignId="props.item._id"
                  :isVisible="props.item.totalIssuedAmount"
                  :section="'ReadyToPay'"
                  :advancePaid="props.item.totalAdvancePaidAmount"
                  :additionalCharges="props.item.totalAdditionalAmount"
                  :jobCurrency="props.item.customerCurrency"
                  @assignment-list-refresh="refresh()"
                />
              </v-layout>
              <div class="assignments-action-stack">
                <v-icon
                  v-if="props.item.isAcknowedged"
                  @click="
                    goToDoc(
                      props.item.jobId,
                      props.item.assignmentId,
                      props.item._id
                    )
                  "
                  color="blue"
                >
                  description
                </v-icon>

                <button
                  v-if="props.item.isAcknowedged"
                  v-permissions="'view-details-jobs'"
                  :disabled="loading"
                  @click="check(props.item.jobId)"
                  target="_blank"
                  color="orange"
                  outline
                  class="pay-ass-btn oms-btn oms-btn--primary"
                >
                  Details
                </button>

                <button
                  v-if="
                    !props.item.hasVasAttached &&
                    !props.item.isGenerated &&
                    props.item.isAcknowedged &&
                    ((props.item.assignmentStatus >= 0 &&
                      props.item.assignmentStatus <= 2) ||
                      props.item.assignmentStatus == 5 ||
                      props.item.assignmentStatus == 8)
                  "
                  v-permissions="'cancel-assignment-jobs'"
                  class="pay-ass-btn button-red oms-btn oms-btn--destructive"
                  @click="checkCancel(props.item.assignmentId)"
                >
                  Cancel
                </button>
              </div>
            </td>
          </template>
          <v-alert
            slot="no-results"
            :value="isNoSearchResult"
            color="blue"
            icon="warning"
            >Your search for "{{ search }}" found no results.</v-alert
          >
          </v-data-table>
        </ScrollableTable>
        <pagination
          :totalPages="totalPages"
          :pages="this.pages"
          @pageNo="page"
          :componentKey="componentKey"
          :type="0"
          :url="paginationURL"
          :callback="callback"
          :action="`assignment`"
          v-on:pagination-load="checkLoading"
        />
        <v-dialog
          v-if="confirmationDialog.cancelAssignment"
          v-model="confirmationDialog.cancelAssignment"
          persistent
          max-width="600"
        >
          <v-card>
            <v-card-title dark dense flat style="background-color: #ffc04c">
              <div class="headline white--text">
                Confirmation of cancellation
              </div>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-flex pt-2 pr-1>
                  <div class="subheading muted caption">
                    Provide cancellation reason
                  </div>
                  <v-select
                    class="pt-0 currencyTitle"
                    v-model="cancelType"
                    :items="cancellationType"
                    label="Select your option"
                    persistent-hint
                    :menu-props="{ offsetY: true }"
                    return-object
                    single-line
                  ></v-select>
                </v-flex>
                <div
                  v-if="cancelType.value == 'Other’s'"
                  class="subheading muted caption"
                >
                  Reason
                </div>
                <v-text-field
                  class="pt-0 currencyTitle"
                  v-if="cancelType.value == 'Other’s'"
                  type="text"
                  single-line
                  label="Enter your reason"
                  required
                  v-model="cancellationReason"
                  :value="cancellationReason"
                />
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-layout>
                <v-btn
                  color="primary darken-1"
                  text
                  @click.native="open3"
                  :loading="loading"
                  >Yes</v-btn
                >
                <v-btn color="grey" @click.native="closeCancelAssignment" text
                  >Cancel</v-btn
                >
              </v-layout>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog
          v-model="dialog5"
          persistent
          :max-width="450"
          :style="{ zIndex: options.zIndex }"
          @keydown.esc="cancel"
        >
          <v-card>
            <v-toolbar
              dark
              style="
                background-color: #fee9d0;
                color: black;
                padding-left: 100px;
              "
              flat
            >
              <v-toolbar-title>{{ cancelTitle1 }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon>
                <v-icon
                  class="heading grey--text text--darken-4"
                  @click.prevent="
                    dialog5 = false;
                    cancelType = '';
                    cancellationReason = null;
                  "
                  >close</v-icon
                >
              </v-btn>
            </v-toolbar>
            <v-spacer class="spacerclass">
              <v-card-text
                style="text-align: center"
                v-show="!!cancelMessage1"
                class="pa-4"
              >
                <div class="pb-4">
                  <img
                    :src="sittingCharacter"
                    height="300"
                    width="300"
                  />
                </div>
                <div class="subheading">{{ cancelMessage1 }}</div>
                <div
                  v-if="cancelType.value == 'Other’s'"
                  class="subheading muted pt-2"
                >
                  <span style="color: darkgrey">Cancellation reason:</span>
                  <p style="word-break: break-all">
                    {{ cancelType.value }} - {{ cancellationReason }}
                  </p>
                </div>
                <div v-else class="subheading muted pt-2">
                  <span style="color: darkgrey">Cancellation reason:</span>
                  {{ cancelType.value }}
                </div>
              </v-card-text>

              <v-card-actions class="pt-2 pb-5" style="justify-content: center">
                <v-btn
                  medium
                  style="text-transform: none !important"
                  color="orange white--text "
                  darken-1
                  :loading="loading"
                  text
                  @click.native="cancelAssignment"
                  >DONE</v-btn
                >
              </v-card-actions>
            </v-spacer>
          </v-card>
        </v-dialog>
        <confirmation-dialog
          :content="`Are you sure to remove transporter from this assignment?`"
          :toShow="confirmationDialog.removeTransporterAssignment"
          :onClose="() => remove()"
          confirmTitle="Unassign"
          :loading="loading"
          :error="error"
          :onConfirm="() => removeTransporterAssignment(this.assignmentData)"
        />
        <confirmation-dialog
          :content="`Are you sure to remove ${
            this.assignmentData.driverData
              ? this.assignmentData.driverData.name
              : ''
          } from this assignment?`"
          :toShow="confirmationDialog.removeDriverAssignment"
          :onClose="removeDriver"
          confirmTitle="Unassign"
          :loading="loading"
          :error="error"
          :onConfirm="() => removeDriverAssignment(this.assignmentData)"
        />
        <confirmation-dialog
          :content="`Have you collected the physical document from the driver ?`"
          :onClose="() => removeReadyToPay()"
          :title="`Ready to Pay Final Payment`"
          :toShow="confirmationDialog.readyToPay"
          :type="1"
          confirmTitle="Yes"
          :loading="loading"
          :error="error"
          :onConfirm="() => removeTransporterAssignment(this.assignmentData)"
        />
      </v-card-text>
      <v-snackbar
        :timeout="3000"
        color="red darken-2"
        v-model="error"
        class="white--text"
        v-if="error"
        >{{ error }}</v-snackbar
      >
    </v-card>
  </div>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import Vue from "vue";
import "moment/locale/es"; // without this line it didn't work
moment.locale("en-in");

import ConfirmationDialog from "@/components/Common/ConfirmationDialog";
import ProofOfDelivery from "@/components/Pop-ups/ProofOfDelivery";
import { DateRangePickerPlugin } from "@syncfusion/ej2-vue-calendars";
import PaymentDone from "@/components/Accounts/Popups/PaymentDone.vue";
import Loading from "vue-loading-overlay";
import additionalChargesPopup from "@/components/JobDocuments/additionalChargesPopup";
import generateAdvancePopup from "@/components/JobDocuments/generateAdvancePopup";
import SendComments from "@/components/Pop-ups/SendComments";
import CommentCell from "@/components/Common/CommentCell";
import ViewDetails from "@/components/Pop-ups/ViewDetails";
import CustomerDetailPopUp from "../Customer/CustomerDetailPopUp";
import PendingAmountList from "@/components/Accounts/Popups/PendingAmountList.vue";
import JobsProfileDriverAssign from "@/components/Jobs/AssignDriver/JobsProfileDriverAssign";
import jobProfileDriverAssignAir from "@/components/Jobs/AssignDriver/jobProfileDriverAssignAir";
import jobProfileDriverAssignSea from "@/components/Jobs/AssignDriver/jobProfileDriverAssignSea";
import GenerateAdvance from "@/components/Pop-ups/GenerateAdvance";
Vue.use(DateRangePickerPlugin);
import activityLogs from "../Common/activityLogs";
import { EventBus } from "../../event-bus.js";
let momentTz = require("moment-timezone");
import PaginationButtons from "@/components/Pagination/PaginationButtons";
import pagination from "@/components/Pagination/pagination";
import AddPhysicalDoc from "@/components/Pop-ups/AddPhysicalDoc";
import EditPhysicalDoc from "@/components/Pop-ups/EditPhysicalDoc";

import {
  StorageKeys,
  JobListTypes,
  CancellationType,
  TruckTypes,
  SeaTypes,
  AirTypes,
} from "../../constants/constants";
import { assignmentList } from "@/constants/datatable-headers.js";
import FilterBoard from "@/components/Common/FilterBoard";
import ScrollableTable from "@/components/Common/ScrollableTable";
import SegmentedControl from "@/components/Common/SegmentedControl";
import sittingCharacter from "@/assets/Character-sitting.png";
import { async } from "q";
export default {
  created() {
    this.getSearchList();
    this.cancellationType = CancellationType;
    this.userId = localStorage.getItem("userId");
    this.JobTypes = JobListTypes;
    this.subTruck = TruckTypes;
    this.TruckTypesList = TruckTypes;

    if (localStorage.getItem("workingCountries")) {
      this.workingCountries = JSON.parse(
        localStorage.getItem("workingCountries")
      );
      let workingCountry = [];
      this.workingCountries.forEach((key, index) => {
        if (key.isSelected) {
          workingCountry.push(key.value);
        }
      });
      if (localStorage.getItem("TabStatusAssign") != null) {
        this.tabStatus = localStorage.getItem("TabStatusAssign");
        this.getsearchTypes(localStorage.getItem("TabStatusAssign"));
      } else {
        this.tabStatus = "Unassigned";
        this.getsearchTypes("Unassigned");
      }

      this.workingCountry = JSON.stringify(workingCountry);
      this.paginationURL = `/dmsAdmin/AssignmentListingView?workingCountry=${this.workingCountry}&isSearch=true&status=${this.tabStatus}`;
      this.getListCount();
    }
    EventBus.$on("countryChanged", (val) => {
      if (this.$route.name == "assignments") {
        this.workingCountry = JSON.stringify(val);
        if (localStorage.getItem("paginationUrlAssignment") !== null) {
          this.updatePaginationUrl();
          this.getListCount();
        } else {
          this.paginationURL = `/dmsAdmin/AssignmentListingView?workingCountry=${this.workingCountry}&isSearch=true&status=${this.tabStatus}`;
          this.getListCount();
        }
      }
    });
    this.$eventBus.$on("assignments", (value) => {
      if (localStorage.getItem("workingCountries")) {
        this.workingCountries = JSON.parse(
          localStorage.getItem("workingCountries")
        );
        let workingCountry = [];
        this.workingCountries.forEach((key, index) => {
          if (key.isSelected) {
            workingCountry.push(key.value);
          }
        });
        this.workingCountry = JSON.stringify(workingCountry);
      }

      if (this.workingCountry.includes(value.workingCountry)) {
        this.componentKey = this.componentKey + 1;
        this.getListCount();
      }
    });
    this.$eventBus.$on("additionalchargeAdd", (value) => {
      if (localStorage.getItem("workingCountries")) {
        this.workingCountries = JSON.parse(
          localStorage.getItem("workingCountries")
        );
        let workingCountry = [];
        this.workingCountries.forEach((key, index) => {
          if (key.isSelected) {
            workingCountry.push(key.value);
          }
        });
        this.workingCountry = JSON.stringify(workingCountry);
      }

      if (this.workingCountry.includes(value.workingCountry)) {
        this.componentKey = this.componentKey + 1;
        this.getListCount();
      }
    });
    this.$eventBus.$on("job-details-purchase-invoice", (data) => {
      this.componentKey = this.componentKey + 1;
    });
  },

  mounted() {
    if (localStorage.getItem("TabStatusAssign") != null) {
      this.tabStatus = localStorage.getItem("TabStatusAssign");
      this.getsearchTypes(localStorage.getItem("TabStatusAssign"));
      this.getListCount();
    } else {
      this.tabStatus = "Unassigned";
      this.getsearchTypes("Unassigned");
      this.getListCount();
    }
  },

  components: {
    FilterBoard,
    ScrollableTable,
    SegmentedControl,
    pagination,
    PaginationButtons,
    JobsProfileDriverAssign,
    jobProfileDriverAssignSea,
    PendingAmountList,
    jobProfileDriverAssignAir,
    activityLogs,
    AddPhysicalDoc,
    EditPhysicalDoc,
    CustomerDetailPopUp,
    CommentCell,
    SendComments,
    additionalChargesPopup,
    ProofOfDelivery,
    generateAdvancePopup,
    Loading,
    GenerateAdvance,
    ConfirmationDialog,
    PaymentDone,
    ViewDetails,
  },
  data() {
    return {
      sittingCharacter,
      componentKey: 0,
      cancelTitle1: null,
      activeMenu: localStorage.getItem("activeMenu"),
      cancelMessage1: null,
      waterMark: "Select a Range",
      dateRange: { startDate: "", endDate: "" },
      startDate: "",
      endDate: "",
      airTypes: AirTypes,
      seaTypes: SeaTypes,
      dateRange2: null,
      cancellationType: [],
      options: {
        color: "#ffc04c",
        width: 450,
        zIndex: 200,
      },
      cancelType: "",
      userId: null,
      assignmentData: {},
      driverDetailHeaders: {
        id: "ID",
        name: "Name",
        phone: "Phone No.",
      },
      transporterDetailHeaders: {
        id: "ID",
        name: "Name",
        email: "Email",
        phone: "Phone No.",
      },
      selectCountryDialog: false,
      isDashboard: true,
      searchTypes: "",
      search: "",
      error: null,
      subTruck: [],
      TruckTypesList: [],
      subTruckType: "",
      advanceStatusList: [],
      assignID: null,
      advanceStatus: "",
      confirmationDialog: {
        cancelAssignment: false,
        makePayment: false,
        completeAssignment: false,
        removeDriverAssignment: false,
        removeTransporterAssignment: false,
        readyToPay: false,
      },
      JobTypes: [],
      subJobType: "",
      waterMark: "Select a Range",
      dateRange2: null,
      dateRange: { startDate: "", endDate: "" },
      workingCountry: null,
      JobListTypes: [],
      pages: 1,
      searchItems: [],
      driverSearchItems: [],
      driverSearch: "",
      driverSearchTypes: "",

      rules: {
        required: (value) => !!value || "This field is required.",
        emailRules: (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/.test(v) ||
          "E-mail must be valid",
        countryCode: (v) =>
          /^(\+?\d{1,3}|\d{1,4})$/.test(v) ||
          "Please Enter Valid Country Code.",
        phoneNumber: (v) =>
          /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/.test(v) ||
          "Please Enter Valid Mobile No.",
        number: (v) => /^[0-9]*$/.test(v) || "Please Enter Valid Price",
      },
      // ----- NOTIFICATION ---
      newUnassigned: 0,
      newInprogress: 0,
      newCompleted: 0,
      x: {
        error: null,
      },
      dialog5: false,
      currentEnquiry: null,
      currentIndex: null,
      paginationURL: ``,

      tabStatus: "",
      tabStatusMain: "Assignment",

      totalInquiry: 0,
      totalDriverAssigned: 0,
      totalFindingDrivers: 0,
      inactiveJob: 0,
      completedJob: 0,
      totalJob: 0,
      totalPages: 0,
      statusList: [],
      statusListInProgress: [],

      statusListCompleted: [],

      assignStatus: "",
      jobStatus: "",
      pagination: {},
      isNoSearchResult: false,
      loading: true,
      server: false,
      headers: assignmentList,
      items: [],
    };
  },
  props: {
    updateList: Number,
  },
  watch: {
    dateRange2(val) {
      if (val) {
        if (val[0] && val[1]) {
          this.startDate = moment(val[0]).format("YYYY-MM-DD");
          this.endDate = moment(val[1]).format("YYYY-MM-DD");
        }
        this.searchData(null, val);
      } else {
        this.startDate = "";
        this.endDate = "";

        this.searchData(null, val);
      }
    },

    pagination(val) {
      let temp_url = "";
      if (val["sortBy"] === "createdDate") {
        if (val["descending"] === true) {
          temp_url = "&toSort=date&sortBy=ascending";
          this.updateQueryStringParameter("toSort", "date");
          this.updateQueryStringParameter("sortBy", "descending");
        } else if (val["descending"] === false) {
          temp_url = "&toSort=date&sortBy=descending";
          this.updateQueryStringParameter("toSort", "date");
          this.updateQueryStringParameter("sortBy", "ascending");
        }
      }
      if (val["sortBy"] === "quote") {
        if (val["descending"] === true) {
          temp_url = "&toSort=price&sortBy=descending";
          this.updateQueryStringParameter("toSort", "price");
          this.updateQueryStringParameter("sortBy", "descending");
        } else if (val["descending"] === false) {
          temp_url = "&toSort=price&sortBy=ascending";
          this.updateQueryStringParameter("toSort", "price");
          this.updateQueryStringParameter("sortBy", "ascending");
        }
      }
      if (!val["sortBy"]) {
        this.removeParam(["toSort", "sortBy"]);
      }
      this.updateQueryStringParameter("isSearch", "true");
      deep: true;
    },
  },
  methods: {
    getAdvanceAmount(data) {
      let pendingAmount = this.getPendingAmountForProps(data, true);
      return `${pendingAmount}  ${data.customerCurrency}`;
    },
    getPendingAmountForProps(data, isDecimal = false) {
      let amountPaidToDriver = data.amountPaidToDriver || 0;
      let adjustAmount = data.amountAdjustedFromThisAssignment || 0;
      let totalAdvance =
        data.paymentAmount -
        (data.totalAdvancePaidAmount - adjustAmount) -
        amountPaidToDriver +
        data.totalAdditionalAmount;

      if (isDecimal) return totalAdvance.toFixed(2);
      else return Number(totalAdvance.toFixed(2));
    },
    refreshOnComment() {
      this.componentKey++;
    },
    getSearchList() {
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };

      const url = `${this.constants.apiUrl}/dmsAdmin/searchListArray`;
      this.axios.get(url, config).then((response) => {
        this.statusListInProgress = response.data.data.assignStatusInProgress;
        this.statusListCompleted = response.data.data.assignStatusCompleted;
        this.advanceStatusList = response.data.data.AdvanceStatusList;
        if (localStorage.getItem("TabStatusAssign") != null) {
          this.tabStatus = localStorage.getItem("TabStatusAssign");
          if (this.tabStatus == "In-progress") {
            this.statusList = this.statusListInProgress;
          } else {
            this.statusList = this.statusListCompleted;
          }
        }
      });
    },
    getTime4(date) {
      return moment(date).format("ll LT");
    },
    getTime5(date) {
      return moment(date).format("LT");
    },
    getDays(day) {
      let finalDate = moment(day);
      // console.log(moment(day).format("ll HH:mm"));
      let dayToday = moment(new Date());

      // let finalDriverDay = moment(finalDate - dayToday).format("E");

      // return finalDriverDay;
    },
    goToDoc(jobId, assignId, _id) {
      this.$router.push(`/documents/${_id}`);
    },
    goToProof(_id) {
      this.$router.push(`/documents/${_id}?type=Driver_Proof`);
    },
    getDays(day) {
      let finalDate = moment(day);
      let dayToday = moment(new Date());
      let remainingDay = finalDate.diff(dayToday, "hours");
      return Math.round(remainingDay / 24);
    },
    cancelAssignment() {
      this.loading = true;
      let url = "/dmsAdmin/cancelAssignment";
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      const data = {
        assignmentId: this.assignID.toString(),
      };
      if (this.cancelType.value) {
        if (this.cancelType.value == "Other’s") {
          data.cancellationReason =
            this.cancelType.value + " - " + this.cancellationReason;
        } else {
          data.cancellationReason = this.cancelType.value;
        }
      }

      this.axios.post(this.constants.apiUrl + url, data, config).then(
        (response) => {
          this.$eventBus.$emit("cancelled");
          this.loading = false;
          this.dialog5 = false;
          this.status = -1;
          this.componentKey = this.componentKey + 1;
          this.closeCancelAssignment();
        },
        (error) => {
          this.loading = false;
          this.error = this.$eventBus.parse(error);
        }
      );
    },
    closeCancelAssignment() {
      this.cancellationReason = null;
      this.confirmationDialog.cancelAssignment = false;
      this.cancelType = "";
    },
    open3(val, index) {
      if (!navigator.onLine) {
        this.loading = false;
        this.error = "Please check your internet connection";
        setTimeout(() => {
          this.x.error = "";
        }, 3000);
        return;
      }
      if (!this.cancelType) {
        this.error = "Please select cancellation reason before moving ahead";
        setTimeout(() => {
          this.x.error = "";
        }, 3000);
        return false;
      }
      if (this.cancelType.value == "Other’s") {
        if (!this.cancellationReason) {
          this.error = "Please enter cancellation reason before moving ahead";
          setTimeout(() => {
            this.x.error = "";
          }, 3000);
          return false;
        }
      }
      this.confirmationDialog.cancelAssignment = false;
      this.dialog5 = true;
      this.cancelTitle1 = "Cancellation Message";
      this.cancelMessage1 = "Your job has been cancelled!";
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    cancel3() {
      this.resolve(false);
      this.dialog5 = false;
    },
    async checkCancel(id) {
      this.operationName = "cancel-assignment-jobs";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        this.assignID = id;
        this.confirmationDialog.cancelAssignment = true;
      } else {
        return;
      }
    },
    redirectTo(type) {
      if (type === "Jobs") {
        if (localStorage.getItem("activeMenu") == 13) {
          this.$router.push(`/procurements`);
        } else {
          this.$router.push(`/jobs`);
        }
      } else {
        this.$router.push(`/assignments`);
      }
    },
    getText(arr = [], val) {
      let finalEl = null;
      finalEl = arr.find((el) => el.value == val);
      return finalEl ? finalEl.text : "NA";
    },
    async check(jobId) {
      this.loading = true;
      this.operationName = "view-details-jobs";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        this.$router.push(`/jobs/${jobId}`);
      } else {
        this.loading = false;
        return;
      }
    },
    getListCount() {
      let v = {};
      this.loading = true;
      let Url = "/dmsAdmin/accountAssignmentDashboard";
      let temp_url = this.paginationURL;
      Url = "/dmsAdmin/AssignmentListingViewCount?" + temp_url.split("?")[1];
      let body = {};
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      this.axios.defaults.headers.common["authorization"] = `bearer ${token}`;
      /* The tab counts keep their last values until the new ones arrive.
         Zeroing them here hid the badges mid-load, so the status tabs
         shrank and grew again on every switch. */
      this.totalJob = 0;
      this.totalPages = 0;
      v = this.axios.get(this.constants.apiUrl + Url, body).then(
        (response) => {
          this.loading = false;
          let countData = response.data.data;
          if (!this.search.trim().length) {
            localStorage.removeItem("searchAssign");
          }
          if (!this.driverSearch.trim().length) {
            localStorage.removeItem("searchAssignDriver");
          }
          this.newUnassigned = countData.upcomingCount;
          this.newInprogress = countData.ongoingCount;
          this.newCompleted = countData.completedCount;
          this.totalJob = countData.countData;
          this.totalPages = Math.ceil(this.totalJob / 15);
        },
        (error) => {}
      );

      return v;
    },
    async callback({ jobInfo, totalData }) {
      this.items = jobInfo;
      this.pagination.rowsPerPage = 15;
      this.$emit("job-load", false);
      window.scrollTo(0, 0);
      this.loading = false;
    },
    refresh() {
      this.componentKey = this.componentKey + 1;
    },
    openTransporterUnassign(assignData) {
      this.confirmationDialog.removeTransporterAssignment = true;
      this.assignmentData = { ...assignData };
    },
    openReadyToPay() {
      this.confirmationDialog.readyToPay = true;
    },
    openDriverUnassign(assignData) {
      this.confirmationDialog.removeDriverAssignment = true;
      this.assignmentData = { ...assignData };
    },
    removeDriver() {
      this.confirmationDialog.removeDriverAssignment = false;
    },
    remove() {
      this.confirmationDialog.removeTransporterAssignment = false;
    },
    removeReadyToPay() {
      this.confirmationDialog.readyToPay = false;
    },
    removeTransporterAssignment(data) {
      if (
        data.assignmentStatus == 2 ||
        data.assignmentStatus == 5 ||
        data.assignmentStatus == 6
      ) {
        this.error = "Please unassign the driver first !";
        this.loading = false;
        return;
      }
      this.loading = true;
      let url = "/dmsAdmin/unassignTransporter";
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      const body = {
        assignmentId: data.assignmentId.toString(),
      };
      this.axios.post(this.constants.apiUrl + url, body, config).then(
        (response) => {
          this.loading = false;
          this.confirmationDialog.removeTransporterAssignment = false;
          this.componentKey = this.componentKey + 1;
        },
        (error) => {
          this.error = this.$eventBus.parse(error);
          this.loading = false;
        }
      );
    },
    removeDriverAssignment(data) {
      if (!data.driverData) {
        return;
      }
      let url = "/dmsAdmin/removeDriver";
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      const body = {
        driverId: data.driverData.driverId.toString(),
        assignmentId: data.assignmentId.toString(),
      };
      this.axios.post(this.constants.apiUrl + url, body, config).then(
        (response) => {
          this.loading = false;
          this.componentKey = this.componentKey + 1;
          this.confirmationDialog.removeDriverAssignment = false;
        },
        (error) => {
          this.error = this.$eventBus.parse(error);
          this.loading = false;
        }
      );
    },

    readyToPay() {},

    updateQueryStringParameter(key, value) {
      var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
      var separator = this.paginationURL.indexOf("?") !== -1 ? "&" : "?";
      if (this.paginationURL.match(re)) {
        this.paginationURL = this.paginationURL.replace(
          re,
          "$1" + key + "=" + value + "$2"
        );
      } else {
        this.paginationURL = this.paginationURL + separator + key + "=" + value;
      }
    },

    updatePaginationUrl() {
      let tempUrl = localStorage.getItem("paginationUrlAssignment");
      let x = tempUrl.split("&");
      let y = x[0].split("=");
      y[1] = this.workingCountry;
      x[0] = y.join("=");
      tempUrl = x.join("&");
      this.paginationURL = tempUrl;
    },

    page(event) {
      this.pages = event;
    },

    goToProfile(jobId) {
      this.$router.push(`/jobs/${jobId}`);
    },
    getTime(time) {
      return moment.unix(time).format("ll");
    },
    getTime3(date) {
      return moment.utc(date).format("ll");
    },
    getStatus(status) {
      switch (status) {
        case 1:
          return "Driver Not Assigned";
        case 2:
          return "Driver Assigned";
        case 3:
          return "Payment Pending";
        case 4:
          return "Payment Done";
        case 5:
          return "In-Transit";
        case 6:
          return "Shipment Offloaded ";

        case -1:
          return "Job Cancelled";
        default:
          return "Unknown";
      }
    },
    getsearchTypes(tabStatus) {
      if (tabStatus === "In-progress" || "Completed") {
        if (tabStatus === "In-progress") {
          this.statusList = this.statusListInProgress;
        } else {
          this.statusList = this.statusListCompleted;
        }
        this.searchItems = this.driverSearchItems = [
          {
            status: "Company/Customer Name",
            abbr: "companyName/customerName",
          },
          { status: "Job ID", abbr: "jobId" },
          { status: "Assignment ID", abbr: "assignmentId" },
          { status: "Driver ID", abbr: "driverId" },
          {
            status: "Driver Name",
            abbr: "driverName",
          },
          { status: "Truck Number", abbr: "truckNumber" },
          { status: "Transporter ID", abbr: "transporterId" },
          {
            status: "Transporter Name",
            abbr: "Transporter Name",
          },
        ];
      }
      if (tabStatus === "Unassigned") {
        this.driverSearchItems = this.searchItems = [
          {
            status: "Company/Customer Name",
            abbr: "companyName/customerName",
          },
          { status: "Job ID", abbr: "jobId" },
          { status: "Assignment ID", abbr: "assignmentId" },
          { status: "Transporter ID", abbr: "transporterId" },
          {
            status: "Transporter Name",
            abbr: "Transporter Name",
          },
        ];
      }
    },
    getsearchTypeList(tabStatus) {
      if (this.searchTypes.abbr) {
        if (tabStatus === "In-progress" || "Completed") {
          this.driverSearchItems = [
            {
              status: "Company/Customer Name",
              abbr: "companyName/customerName",
            },
            { status: "Job ID", abbr: "jobId" },
            { status: "Assignment ID", abbr: "assignmentId" },
            { status: "Driver ID", abbr: "driverId" },
            {
              status: "Driver Name",
              abbr: "driverName",
            },
            { status: "Truck Number", abbr: "truckNumber" },
            { status: "Transporter ID", abbr: "transporterId" },
            {
              status: "Transporter Name",
              abbr: "Transporter Name",
            },
          ];
        }
        if (tabStatus === "Unassigned") {
          this.driverSearchItems = [
            {
              status: "Company/Customer Name",
              abbr: "companyName/customerName",
            },
            { status: "Job ID", abbr: "jobId" },
            { status: "Assignment ID", abbr: "assignmentId" },
            { status: "Transporter ID", abbr: "transporterId" },
            {
              status: "Transporter Name",
              abbr: "Transporter Name",
            },
          ];
        }
        this.driverSearchItems.forEach((k) => {
          if (k["abbr"] == this.searchTypes.abbr) {
            let elementPos = this.driverSearchItems
              .map(function (x) {
                return x.abbr;
              })
              .indexOf(k["abbr"]);

            this.driverSearchItems.splice(elementPos, 1);
          }
        });
      }
      if (this.driverSearchTypes.abbr) {
        if (tabStatus === "In-progress" || "Completed") {
          this.searchItems = [
            {
              status: "Company/Customer Name",
              abbr: "companyName/customerName",
            },
            { status: "Job ID", abbr: "jobId" },
            { status: "Assignment ID", abbr: "assignmentId" },
            { status: "Driver ID", abbr: "driverId" },
            {
              status: "Driver Name",
              abbr: "driverName",
            },
            { status: "Truck Number", abbr: "truckNumber" },
            { status: "Transporter ID", abbr: "transporterId" },
            {
              status: "Transporter Name",
              abbr: "Transporter Name",
            },
          ];
        }
        if (tabStatus === "Unassigned") {
          this.searchItems = [
            {
              status: "Company/Customer Name",
              abbr: "companyName/customerName",
            },
            { status: "Job ID", abbr: "jobId" },
            { status: "Assignment ID", abbr: "assignmentId" },
            { status: "Transporter ID", abbr: "transporterId" },
            {
              status: "Transporter Name",
              abbr: "Transporter Name",
            },
          ];
        }
        this.searchItems.forEach((k) => {
          if (k["abbr"] == this.driverSearchTypes.abbr) {
            let elementPos = this.searchItems
              .map(function (x) {
                return x.abbr;
              })
              .indexOf(k["abbr"]);

            this.searchItems.splice(elementPos, 1);
          }
        });
      }
    },
    searchTabStatus(jobStatusVal, url) {
      if (jobStatusVal) {
        localStorage.setItem("TabStatusAssign", jobStatusVal);
        if (jobStatusVal === "In-progress" || "Completed") {
          this.assignStatus = "";
          if (jobStatusVal === "In-progress") {
            this.statusList = this.statusListInProgress;
          } else {
            this.statusList = this.statusListCompleted;
          }
          this.searchItems = [
            {
              status: "Company/Customer Name",
              abbr: "companyName/customerName",
            },
            { status: "Job ID", abbr: "jobId" },
            { status: "Assignment ID", abbr: "assignmentId" },
            { status: "Driver ID", abbr: "driverId" },
            {
              status: "Driver Name",
              abbr: "driverName",
            },
            { status: "Truck Number", abbr: "truckNumber" },
            { status: "Transporter ID", abbr: "transporterId" },
            {
              status: "Transporter Name",
              abbr: "Transporter Name",
            },
          ];
          this.driverSearchItems = [
            {
              status: "Company/Customer Name",
              abbr: "companyName/customerName",
            },
            { status: "Job ID", abbr: "jobId" },
            { status: "Assignment ID", abbr: "assignmentId" },
            { status: "Driver ID", abbr: "driverId" },
            {
              status: "Driver Name",
              abbr: "driverName",
            },
            { status: "Truck Number", abbr: "truckNumber" },
            { status: "Transporter ID", abbr: "transporterId" },
            {
              status: "Transporter Name",
              abbr: "Transporter Name",
            },
          ];
          this.driverSearchItems.forEach((k) => {
            if (k["abbr"] == this.searchTypes.abbr) {
              let elementPos = this.driverSearchItems
                .map(function (x) {
                  return x.abbr;
                })
                .indexOf(k["abbr"]);

              this.driverSearchItems.splice(elementPos, 1);
            }
          });
          this.searchItems.forEach((k) => {
            if (k["abbr"] == this.driverSearchTypes.abbr) {
              let elementPos = this.searchItems
                .map(function (x) {
                  return x.abbr;
                })
                .indexOf(k["abbr"]);

              this.searchItems.splice(elementPos, 1);
            }
          });
        }
        if (jobStatusVal === "Unassigned") {
          this.search = "";
          this.driverSearchTypes = "";
          this.driverSearch = "";
          this.searchTypes = "";
          this.advanceStatus = "";
          this.assignStatus = "";
          this.searchItems = [
            {
              status: "Company/Customer Name",
              abbr: "companyName/customerName",
            },
            { status: "Job ID", abbr: "jobId" },
            { status: "Assignment ID", abbr: "assignmentId" },
            { status: "Transporter ID", abbr: "transporterId" },
            {
              status: "Transporter Name",
              abbr: "Transporter Name",
            },
          ];
          this.driverSearchItems = [
            {
              status: "Company/Customer Name",
              abbr: "companyName/customerName",
            },
            { status: "Job ID", abbr: "jobId" },
            { status: "Assignment ID", abbr: "assignmentId" },
            { status: "Transporter ID", abbr: "transporterId" },
            {
              status: "Transporter Name",
              abbr: "Transporter Name",
            },
          ];
          this.driverSearchItems.forEach((k) => {
            if (k["abbr"] == this.searchTypes.abbr) {
              let elementPos = this.driverSearchItems
                .map(function (x) {
                  return x.abbr;
                })
                .indexOf(k["abbr"]);

              this.driverSearchItems.splice(elementPos, 1);
            }
          });
          this.searchItems.forEach((k) => {
            if (k["abbr"] == this.driverSearchTypes.abbr) {
              let elementPos = this.searchItems
                .map(function (x) {
                  return x.abbr;
                })
                .indexOf(k["abbr"]);

              this.searchItems.splice(elementPos, 1);
            }
          });
        }
        this.paginationURL = "";
        this.tabStatus = jobStatusVal;
        url.push(`status=${jobStatusVal}`);
      } else {
        this.jobStatus = this.tabStatus;
        url.push(`status=${this.tabStatus}`);
      }
    },
    filter_toggle() {
      var x = document.getElementById("filter-toggle");

      if (x.style.display === "block") {
        this.subJobType = "";
        this.subTruckType = "";
        x.style.display = "none";
        this.searchData();
      } else {
        x.style.display = "block";
      }
    },
    searchData(jobStatusVal = null, dateRangeVal = null) {
      if (
        this.subJobType.value == "airFreight" ||
        this.subJobType.value == "seaFreight"
      ) {
        this.subTruckType = "";
      }
      if (!navigator.onLine) {
        this.loading = false;
        this.x.error = "Please check your internet connection";
        setTimeout(() => {
          this.x.error = "";
        }, 3000);
        return;
      }

      let timezone = momentTz.tz.guess(); //not used
      let url = [];
      url.push(`workingCountry=${this.workingCountry}`);

      url.push(`isSearch=true`);
      this.getsearchTypeList(this.tabStatus);
      this.searchTabStatus(jobStatusVal, url);
      if (this.subJobType.value) {
        //   localStorage.setItem("subJobTypePro", JSON.stringify(this.subJobType));
        url.push(`jobType=${this.subJobType.value}`);
      }
      if (this.subTruckType) {
        //   localStorage.setItem("subJobTypePro", JSON.stringify(this.subJobType));
        url.push(`truckType=${this.subTruckType}`);
      }
      if (this.assignStatus) {
        //   localStorage.setItem("subJobTypePro", JSON.stringify(this.subJobType));
        url.push(`assignmentStatus=${this.assignStatus}`);
      }
      if (this.advanceStatus) {
        //   localStorage.setItem("subJobTypePro", JSON.stringify(this.subJobType));
        url.push(`advanceStatus=${this.advanceStatus}`);
      }

      if (this.search.trim().length > 0 && this.searchTypes) {
        localStorage.setItem("searchAssign", this.search);
        url.push(`searchType=${this.searchTypes.abbr}`);
        url.push(`searchText=${this.search}`);
      } else if (this.searchTypes) {
        this.loading = false;
        if (!localStorage.getItem("searchAssign")) {
        } else {
        }
        this.search = "";
      }

      if (dateRangeVal) {
        url.push(`startDate=${this.startDate}`);
        url.push(`endDate=${this.endDate}`);
      } else if (this.startDate.length > 0) {
        url.push(`startDate=${this.startDate}`);
        url.push(`endDate=${this.endDate}`);
      }

      if (this.driverSearch.trim().length > 0 && this.driverSearchTypes) {
        this.isDashboard = false;
        localStorage.setItem("searchAssignDriver", this.driverSearch);
        url.push(`searchTextTwo=${this.driverSearch}`);
        url.push(`searchTypeTwo=${this.driverSearchTypes.abbr}`);
      } else if (this.driverSearchTypes) {
        this.loading = false;
        this.isDashboard = true;
        if (!localStorage.getItem("searchAssignDriver")) {
        } else {
        }
        this.driverSearch = "";
      }

      let finalUrl = "/dmsAdmin/AssignmentListingView?";
      if (url.length > 0) {
        let params = url.join("&");
        finalUrl = finalUrl + params;
      } else return "";
      this.paginationURL = finalUrl;
      if (
        localStorage.getItem("searchAssign") ||
        localStorage.getItem("searchAssignDriver") ||
        this.subJobType ||
        this.advanceStatus ||
        this.assignStatus ||
        this.subTruckType ||
        jobStatusVal ||
        dateRangeVal
      ) {
        this.getListCount();
      } else {
      }
    },
    reset() {
      if (!this.dateRange2) {
        this.getListCount();
      }
      if (this.tabStatus === "In-progress" || "Completed") {
        this.assignStatus = "";

        if (this.tabStatus === "In-progress") {
          this.statusList = this.statusListInProgress;
        } else if (this.tabStatus === "Completed") {
          this.statusList = this.statusListCompleted;
        }
        this.driverSearchItems = this.searchItems = [
          {
            status: "Company/Customer Name",
            abbr: "companyName/customerName",
          },
          { status: "Job ID", abbr: "jobId" },
          { status: "Assignment ID", abbr: "assignmentId" },
          { status: "Driver ID", abbr: "driverId" },
          {
            status: "Driver Name",
            abbr: "driverName",
          },
          { status: "Truck Number", abbr: "truckNumber" },
          { status: "Transporter ID", abbr: "transporterId" },
          {
            status: "Transporter Name",
            abbr: "Transporter Name",
          },
        ];
      }
      localStorage.removeItem("paginationUrlAssignment");
      localStorage.removeItem("searchAssign");
      localStorage.removeItem("searchAssignDriver");

      if (this.tabStatus === "Unassigned") {
        this.driverSearchItems = this.searchItems = [
          {
            status: "Company/Customer Name",
            abbr: "companyName/customerName",
          },
          { status: "Job ID", abbr: "jobId" },
          { status: "Assignment ID", abbr: "assignmentId" },
          { status: "Transporter ID", abbr: "transporterId" },
          {
            status: "Transporter Name",
            abbr: "Transporter Name",
          },
        ];
      }
      if (!navigator.onLine) {
        this.loading = false;
        this.x.error = "Please check your internet connection";
        setTimeout(() => {
          this.x.xerror = "";
        }, 3000);
        return;
      }
      this.jobStatus = this.tabStatus;
      this.assignStatus = "";
      this.advanceStatus = "";
      this.startDate = "";
      this.select = { status: "", abbr: "" };
      this.selects = { status: "", abbr: "" };
      this.status = "";
      this.dateRange2 = null;
      this.subJobType = "";
      this.subTruckType = "";
      this.dateRange2 = null;
      this.startDate = "";
      this.endDate = "";
      this.executive = "";
      this.search = "";
      this.driverSearchTypes = "";
      this.isDashboard = true;
      this.driverSearch = "";
      this.searchTypes = "";
      this.paginationURL = `/dmsAdmin/AssignmentListingView?workingCountry=${this.workingCountry}&isSearch=true&status=${this.jobStatus}`;

      return;
    },
    checkLoading(event) {
      if (event) {
        this.loading = true;
      } else {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss">
#filter_data_toggle .flex.xs2.pr-2 > div {
  padding-top: 0 !important;
}
.divider-style {
  margin-bottom: 24px;
  margin-top: 15px;
  background: lightgrey;
}
.searchAccounts .v-label.v-label--is-disabled.theme--light {
  left: 10px !important;
}

.searchAccounts .theme--light.v-label {
  left: 10px !important;
}
.searchAccounts input {
  padding-left: 10px !important;
}

td {
  font-size: 16px !important;
}

thead {
  background: #fbfbfb;
}

.assignments-revamp {
  --assign-bg: #f5f7fb;
  --assign-panel: #ffffff;
  --assign-ink: #172033;
  --assign-navy: #0f172a;
  --assign-muted: #657084;
  --assign-primary: #f58220;
  --assign-primary-dark: #b95d07;
  --assign-primary-soft: #fff3e6;
  --assign-border: #e4e8f0;
  --assign-row: #ffffff;
  --assign-shadow: 0 16px 40px rgba(23, 32, 51, 0.08);
  background: var(--assign-bg);
  color: var(--assign-ink);
  min-height: calc(100vh - 54px);
  padding: 4px;
}

.assignments-panel {
  background: var(--assign-panel) !important;
  border: 0 !important;
  border-radius: 8px !important;
  box-shadow: var(--assign-shadow) !important;
  overflow: hidden;
}

.assignments-nav-grid {
  align-items: center;
  background: #ffffff;
  border-bottom: 1px solid #edf1f7;
  display: grid;
  gap: 12px;
  grid-template-columns: minmax(260px, 0.5fr) minmax(360px, 1fr);
  padding: 12px 30px;
}

.assignments-nav-grid .assignments-status-tabs {
  justify-self: end;
}

.assignments-nav-grid .assignments-primary-tabs,
.assignments-nav-grid .assignments-status-tabs {
  max-width: 100%;
  width: fit-content;
}

.assignments-status-tabs ::v-deep .segmented-control__item--active {
  background: #fff7ed;
  color: var(--assign-primary-dark);
}

.assignments-board-head {
  align-items: flex-start;
  background:
    linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.98) 0%,
      rgba(248, 250, 252, 0.98) 62%,
      rgba(255, 247, 237, 0.98) 100%
    ),
    #ffffff;
  border-bottom: 1px solid #e6ebf2;
  display: flex;
  gap: 24px;
  justify-content: space-between;
  padding: 18px 30px;
}

.assignments-title-area span {
  color: var(--assign-primary-dark);
  display: block;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: uppercase;
}

.assignments-title-area h1 {
  color: var(--assign-navy);
  font-size: 26px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 1.2;
  margin: 4px 0 0;
}

.assignments-tab-stack {
  display: grid;
  gap: 8px;
  max-width: 720px;
  min-width: 0;
  width: 100%;
}

.assignments-revamp .assignments-primary-tabs,
.assignments-revamp .assignments-status-tabs {
  border-radius: 8px;
  overflow-x: auto !important;
  overflow-y: hidden !important;
}

.assignments-revamp .assignments-primary-tabs .v-tabs__bar,
.assignments-revamp .assignments-status-tabs .v-tabs__bar {
  background: #f2f4f8 !important;
  border: 1px solid var(--assign-border);
  border-radius: 8px;
  box-shadow: none !important;
  min-height: 42px;
  padding: 5px;
}

.assignments-revamp .assignments-primary-tabs .v-tabs__container,
.assignments-revamp .assignments-status-tabs .v-tabs__container {
  min-height: 32px;
}

.assignments-revamp .assignments-primary-tabs .v-tabs__item,
.assignments-revamp .assignments-status-tabs .v-tabs__item {
  border-radius: 7px;
  color: var(--assign-muted) !important;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0;
  min-height: 32px;
  padding: 7px 12px;
  text-transform: none;
}

.assignments-revamp .assignments-primary-tabs .v-tabs__item--active,
.assignments-revamp .assignments-status-tabs .v-tabs__item--active {
  background: #ffffff;
  box-shadow: 0 5px 16px rgba(23, 32, 51, 0.09);
  color: var(--assign-primary-dark) !important;
}

.assignments-revamp .v-tabs__slider {
  display: none;
}

.assignments-stats-grid {
  background: #ffffff;
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  padding: 14px 30px;
}

.assignments-stat-card {
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.94), #ffffff),
    var(--assign-row);
  border: 1px solid var(--assign-border);
  border-radius: 8px;
  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.04);
  min-height: 78px;
  padding: 13px 14px 12px 52px;
  position: relative;
}

.assignments-stat-card::before {
  background: linear-gradient(180deg, var(--assign-primary), transparent);
  border-radius: 8px 0 0 8px;
  content: "";
  inset: 0 auto 0 0;
  opacity: 0.9;
  position: absolute;
  width: 4px;
}

.assignments-stat-card::after {
  display: none;
}

.assignments-stat-icon {
  align-items: center;
  background: var(--assign-primary);
  border-radius: 8px;
  display: flex;
  height: 32px;
  justify-content: center;
  left: 14px;
  position: absolute;
  top: 14px;
  width: 32px;
}

.assignments-stat-icon .v-icon {
  color: #ffffff;
  font-size: 18px;
}

.assignments-stat-card--moving::before,
.assignments-stat-card--moving .assignments-stat-icon {
  background: #2563eb;
}

.assignments-stat-card--done::before,
.assignments-stat-card--done .assignments-stat-icon {
  background: #16a34a;
}

.assignments-stat-card--total::before,
.assignments-stat-card--total .assignments-stat-icon {
  background: #2563eb;
}

.assignments-stat-card span {
  color: var(--assign-muted);
  display: block;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: uppercase;
}

.assignments-stat-card strong {
  color: var(--assign-ink);
  display: block;
  font-size: 24px;
  font-weight: 700;
  line-height: 1;
  margin-top: 5px;
}

.assignments-stat-card small {
  color: #94a3b8;
  display: block;
  font-size: 11px;
  font-weight: 700;
  margin-top: 4px;
}

.assignments-legacy-spacer {
  display: none !important;
}

.assignments-filter-panel {
  background: linear-gradient(180deg, #ffffff 0%, #fbfcfe 100%);
  border: 1px solid var(--assign-border);
  border-bottom: 0;
  border-radius: 8px 8px 0 0;
  margin: 0 30px;
  max-width: none;
  padding: 12px 14px !important;
}

.assignments-section-title {
  margin-bottom: 12px;
}

.assignments-section-title span {
  color: var(--assign-primary-dark);
  display: block;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0;
  text-transform: uppercase;
}

.assignments-section-title h2 {
  color: var(--assign-navy);
  font-size: 18px;
  font-weight: 800;
  letter-spacing: 0;
  line-height: 1.2;
  margin: 4px 0 0;
  text-transform: capitalize;
}

.assignments-filter-panel--advanced {
  border-bottom: 1px solid var(--assign-border);
  border-radius: 0;
  border-top: 0;
}

.assignments-filter-grid {
  align-items: stretch;
  display: grid !important;
  gap: 10px;
  grid-template-columns:
    minmax(140px, 0.85fr)
    minmax(220px, 1.3fr)
    minmax(140px, 0.85fr)
    minmax(220px, 1.3fr)
    minmax(150px, 0.9fr)
    minmax(150px, 0.9fr)
    minmax(180px, 1fr)
    minmax(72px, auto)
    minmax(48px, auto);
  margin: 0 !important;
}

.assignments-filter-grid--advanced {
  grid-template-columns: minmax(160px, 0.85fr) minmax(190px, 1fr);
}

.assignments-filter-grid > .flex {
  align-items: stretch;
  display: flex !important;
  flex-basis: auto !important;
  max-width: none !important;
  min-height: 42px;
  min-width: 0;
  padding: 0 !important;
  width: 100%;
}

.assignments-revamp .divider-style {
  display: none;
}

.assignments-revamp .reset-btn .v-card__actions {
  align-items: stretch;
  padding: 0;
}

/* The search inputs sit on one column instead of spanning two. At double width
   they dominated the board, and each now matches the Search Type it pairs
   with. */
#nav
  .assignments-revamp
  .assignments-filter-panel
  .oms-filter-board__field--search {
  grid-column: auto;
}

#nav .assignments-revamp .assignments-filter-panel .oms-filter-board__reset {
  min-width: 0 !important;
  padding: 0 0.625rem !important;
}

.assignments-revamp .assignments-filter-panel .v-input,
.assignments-revamp .assignments-filter-panel .wrapper.date_9 {
  margin: 0 !important;
  padding: 0 !important;
  width: 100%;
}

.assignments-revamp .assignments-filter-panel .v-input__control,
.assignments-revamp .assignments-filter-panel .v-input__slot,
.assignments-revamp .assignments-filter-panel .v-select__slot,
.assignments-revamp .assignments-filter-panel .v-text-field__slot {
  min-height: 42px !important;
  width: 100%;
}

.assignments-revamp .assignments-filter-panel .v-input__slot,
.assignments-revamp .assignments-filter-panel .e-input-group {
  align-items: center !important;
  background: #fbfcfe !important;
  border: 1px solid #dfe4ec !important;
  border-radius: 8px !important;
  box-shadow: none !important;
  box-sizing: border-box;
  height: 42px !important;
  margin: 0 !important;
  padding: 0 12px !important;
}

.assignments-revamp .assignments-filter-panel .e-input-group {
  padding: 6px 10px !important;
}

.assignments-revamp .assignments-filter-panel .v-text-field__details {
  display: none;
}

.assignments-revamp .assignments-filter-panel .v-label,
.assignments-revamp .assignments-filter-panel .v-select__selection,
.assignments-revamp .assignments-filter-panel input {
  color: #5f6878 !important;
  font-size: 13px;
  font-weight: 700;
}

.assignments-revamp .assignments-filter-panel .v-icon {
  color: #64748b;
  font-size: 18px;
}

.assignments-table-card {
  background: #ffffff;
  padding: 0 30px 28px !important;
  overflow: visible;
}

.assignments-table-scroll {
  max-width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.assignments-attention-icon {
  display: block;
  height: 3.75rem;
  width: 3.75rem;
}

.assignments-revamp #jobsTable {
  background: transparent;
}

.assignments-revamp #jobsTable .v-table__overflow {
  background: #ffffff;
  border: 1px solid var(--assign-border);
  border-radius: 0 0 8px 8px;
  overflow-x: auto;
}

.assignments-revamp #jobsTable table.v-table {
  border-collapse: separate;
  border-spacing: 0 0.375rem;
  min-width: 100%;
  table-layout: auto;
}

.assignments-revamp #jobsTable table.v-table thead tr {
  background: transparent;
}

.assignments-revamp #jobsTable table.v-table thead th,
.assignments-revamp #jobsTable table.v-table thead th.table-header-item {
  background: #f8fafc !important;
  border-bottom: 1px solid #e2e8f0 !important;
  box-sizing: border-box;
  color: #5f6b7a !important;
  font-size: 0.6875rem;
  font-weight: 600;
  height: 2.75rem;
  letter-spacing: 0.04em;
  line-height: 1.2;
  padding: 0.625rem 0.75rem !important;
  position: sticky;
  text-align: center !important;
  text-transform: uppercase;
  top: 0;
  vertical-align: middle;
  white-space: normal;
  word-break: normal;
  z-index: 2;
}

.assignments-revamp #jobsTable table.v-table thead th:first-child {
  border-radius: 8px 0 0 8px;
}

.assignments-revamp #jobsTable table.v-table thead th:last-child {
  border-radius: 0 8px 8px 0;
}

.assignments-revamp #jobsTable table.v-table tbody tr {
  background: var(--assign-row);
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.045);
  transition: box-shadow 0.16s ease, transform 0.16s ease;
}

.assignments-revamp #jobsTable table.v-table tbody tr:hover {
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.12);
  transform: translateY(-1px);
}

.assignments-revamp #jobsTable table.v-table tbody tr:hover td {
  background: #fbfdff;
}

.assignments-revamp #jobsTable table.v-table tbody td {
  background: var(--assign-row);
  border-bottom: 1px solid #e7ecf3 !important;
  border-left: 0 !important;
  border-right: 0 !important;
  border-top: 1px solid #e7ecf3 !important;
  color: #2e3748;
  font-size: 0.8125rem !important;
  height: auto;
  line-height: 1.35;
  overflow-wrap: break-word;
  padding: 0.75rem !important;
  text-align: center !important;
  vertical-align: middle;
  white-space: normal;
  word-break: normal;
}

.assignments-revamp #jobsTable table.v-table tbody td:first-child {
  border-left: 4px solid var(--assign-primary) !important;
  border-radius: 8px 0 0 8px;
  color: var(--assign-primary-dark);
  font-weight: 700;
  padding-left: 0.625rem !important;
}

.assignments-revamp #jobsTable table.v-table tbody td:last-child {
  border-radius: 0 8px 8px 0;
  border-right: 1px solid #eef1f5 !important;
}

.assignments-revamp #jobsTable table.v-table tbody tr:hover td:first-child {
  border-left-color: #2563eb !important;
}

.assignments-job-td .layout {
  align-items: center;
  display: flex;
  gap: 0.4375rem;
  margin: 0 !important;
  min-width: 0;
}

.assignments-job-td .blink__icon {
  flex: 0 0 1.125rem !important;
  max-width: 1.125rem !important;
  min-width: 1.125rem;
  padding: 0 !important;
}

.assignments-job-td svg {
  height: 1.125rem;
  width: 1.125rem;
}

.assignments-job-id {
  color: #0f172a;
  display: inline-block;
  font-size: 0.9375rem;
  font-weight: 800;
  letter-spacing: 0;
  min-width: 0;
  overflow: hidden;
  padding-left: 0.1875rem;
  padding-top: 0.25rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.assignments-date-line {
  color: var(--assign-muted);
  font-size: 0.6875rem;
  font-weight: 700;
  line-height: 1.2;
  margin-top: 0.25rem;
  white-space: nowrap;
}

.assignments-assignment-cell {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 0.4375rem;
  min-width: 0;
}

.assignments-id-value {
  color: #0f172a;
  display: block;
  font-size: 0.9375rem;
  font-weight: 800;
  letter-spacing: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.assignments-id-value--vas {
  color: #3157d5;
}

.assignments-status-pill {
  align-items: center;
  background: #f1f5f9;
  border-radius: 999rem;
  color: #475569;
  display: inline-flex;
  font-size: 0.6875rem;
  font-weight: 800;
  justify-content: center;
  letter-spacing: 0;
  line-height: 1.2;
  max-width: 100%;
  min-height: 1.875rem;
  min-width: 7rem;
  overflow-wrap: normal;
  padding: 0.5rem 0.625rem;
  text-align: center;
  word-break: normal;
}

.assignments-status-pill--open {
  background: #fff7ed;
  color: #c2410c;
}

.assignments-status-pill--moving {
  background: #eff6ff;
  color: #1d4ed8;
}

.assignments-status-pill--pending {
  background: #fef3c7;
  color: #92400e;
}

.assignments-status-pill--done {
  background: #ecfdf5;
  color: #047857;
}

.assignments-status-pill--cancelled {
  background: #fef2f2;
  color: #b91c1c;
}

/* Customer Details stacks name / phone / button centered, so the column reads
   the same way the Driver Details column beside it does. */
.assignments-customer-cell {
  align-items: center;
  display: flex;
  flex-direction: column;
  line-height: 1.35;
}

.assignments-customer-cell__phone {
  white-space: nowrap;
}

.assignments-customer-cell > .customer-detail-popup {
  margin-top: 0.25rem;
}

/* Columns size themselves to their content (table-layout: auto); the only
   constraint is that no column may collapse narrower than its own header. */
.assignments-revamp #jobsTable table.v-table th,
.assignments-revamp #jobsTable table.v-table td {
  width: auto;
}

.assignments-revamp .track-ass-btn,
.assignments-revamp .track-assign-btn,
.assignments-revamp .payy-ass-btn,
.assignments-revamp .pay-ass-btn,
.assignments-revamp .reset-btn-color {
  align-items: center !important;
  background: var(--assign-primary) !important;
  border: 0 !important;
  border-radius: 8px !important;
  box-shadow: 0 5px 12px rgba(245, 130, 32, 0.24) !important;
  color: #ffffff !important;
  cursor: pointer;
  display: inline-flex !important;
  font-family: inherit;
  font-size: 12px !important;
  font-weight: 700 !important;
  gap: 6px;
  justify-content: center;
  letter-spacing: 0 !important;
  line-height: 14px !important;
  margin: 0 auto 8px !important;
  min-height: 32px !important;
  min-width: max-content !important;
  padding: 7px 11px !important;
  text-decoration: none !important;
  text-transform: none !important;
  transition: transform 0.16s ease, box-shadow 0.16s ease;
  white-space: nowrap !important;
}

.assignments-revamp .track-ass-btn:hover,
.assignments-revamp .track-assign-btn:hover,
.assignments-revamp .payy-ass-btn:hover,
.assignments-revamp .pay-ass-btn:hover,
.assignments-revamp .reset-btn-color:hover {
  box-shadow: 0 9px 18px rgba(245, 130, 32, 0.3) !important;
  transform: translateY(-1px);
}

.assignments-revamp #jobsTable table.v-table tbody td:nth-child(4) > div,
.assignments-revamp #jobsTable table.v-table tbody td:nth-child(5) > div,
.assignments-revamp #jobsTable table.v-table tbody td:nth-child(8) > div,
.assignments-revamp #jobsTable table.v-table tbody td:nth-child(11) > div,
.assignments-revamp #jobsTable table.v-table tbody td:nth-child(13) > div,
.assignments-revamp #jobsTable table.v-table tbody td:nth-child(13) > .layout,
.assignments-revamp #jobsTable table.v-table tbody td:last-child > .assignments-action-stack {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
}

.assignments-revamp .track-ass-btn:last-child,
.assignments-revamp .track-assign-btn:last-child,
.assignments-revamp .payy-ass-btn:last-child,
.assignments-revamp .pay-ass-btn:last-child {
  margin-bottom: 0 !important;
}

.assignments-revamp .assignments-final-payment-cell {
  text-align: center !important;
}

.assignments-revamp .assignments-final-payment-cell > .layout,
.assignments-revamp .assignments-ready-doc-row,
.assignments-revamp .assignments-ready-doc-row .log {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  justify-content: center;
  margin-left: auto !important;
  margin-right: auto !important;
  width: 100%;
}

.assignments-revamp .assignments-ready-doc-row .assignment-list-ready-doc-btn {
  font-size: 0.6875rem !important;
  height: auto !important;
  line-height: 1.1 !important;
  margin: 0 auto !important;
  max-width: max-content !important;
  min-height: 1.5rem !important;
  min-width: max-content !important;
  padding: 0.1875rem 0.5rem !important;
  text-align: center;
  white-space: nowrap !important;
  width: auto !important;
}

.assignments-comment-wrap {
  align-items: center;
  display: flex;
  gap: 8px;
  justify-content: center;
  min-width: 0;
  width: 100%;
}

.assignments-comment-text {
  color: #475569;
  flex: 1 1 auto;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.35;
  min-width: 0;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.assignments-comment-text--empty {
  color: #94a3b8;
  font-weight: 600;
}

.assignments-comment-action {
  display: inline-flex;
  flex: 0 0 auto;
}

.assignments-comment-action ::v-deep .track-ass-btn.assign-button,
.assignments-comment-action ::v-deep .comment_btn.blue-button {
  align-items: center !important;
  background: #ffffff !important;
  border: 1px solid #dfe5ee !important;
  border-radius: 999px !important;
  box-shadow: none !important;
  color: #667085 !important;
  display: inline-flex !important;
  font-size: 0 !important;
  height: 32px !important;
  justify-content: center !important;
  line-height: 1 !important;
  margin: 0 !important;
  min-width: 32px !important;
  padding: 0 !important;
  width: 32px !important;
}

.assignments-comment-action ::v-deep .track-ass-btn.assign-button:hover,
.assignments-comment-action ::v-deep .comment_btn.blue-button:hover {
  background: #fff7ed !important;
  border-color: #fed7aa !important;
  color: var(--assign-primary-dark) !important;
}

.assignments-comment-action ::v-deep .track-ass-btn.assign-button::before {
  content: "+";
  font-size: 20px;
  font-weight: 500;
  line-height: 1;
}

.assignments-comment-action ::v-deep .comment_btn.blue-button .v-btn__content {
  align-items: center;
  color: inherit !important;
  display: inline-flex;
  font-size: 0;
  justify-content: center;
  line-height: 1;
}

.assignments-comment-action
  ::v-deep
  .comment_btn.blue-button
  .v-btn__content::before {
  content: "+";
  font-size: 20px;
  font-weight: 500;
  line-height: 1;
}

.assignments-comment-wrap {
  align-items: center;
  display: flex;
  gap: 8px;
  justify-content: center;
  min-width: 0;
  width: 100%;
}

.assignments-comment-text {
  color: #475569;
  flex: 1 1 auto;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.35;
  min-width: 0;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.assignments-comment-text--empty {
  color: #94a3b8;
  font-weight: 600;
}

.assignments-comment-action {
  display: inline-flex;
  flex: 0 0 auto;
}

.assignments-comment-action ::v-deep .track-ass-btn.assign-button,
.assignments-comment-action ::v-deep .comment_btn.blue-button {
  align-items: center !important;
  background: #ffffff !important;
  border: 1px solid #dfe5ee !important;
  border-radius: 999px !important;
  box-shadow: none !important;
  color: #667085 !important;
  display: inline-flex !important;
  font-size: 0 !important;
  height: 32px !important;
  justify-content: center !important;
  line-height: 1 !important;
  margin: 0 !important;
  min-width: 32px !important;
  padding: 0 !important;
  width: 32px !important;
}

.assignments-comment-action ::v-deep .track-ass-btn.assign-button:hover,
.assignments-comment-action ::v-deep .comment_btn.blue-button:hover {
  background: #fff7ed !important;
  border-color: #fed7aa !important;
  color: var(--assign-primary-dark) !important;
}

.assignments-comment-action ::v-deep .track-ass-btn.assign-button::before {
  content: "+";
  font-size: 20px;
  font-weight: 500;
  line-height: 1;
}

.assignments-comment-action ::v-deep .comment_btn.blue-button .v-btn__content {
  align-items: center;
  color: inherit !important;
  display: inline-flex;
  font-size: 0;
  justify-content: center;
  line-height: 1;
}

.assignments-comment-action
  ::v-deep
  .comment_btn.blue-button
  .v-btn__content::before {
  content: "+";
  font-size: 20px;
  font-weight: 500;
  line-height: 1;
}

.assignments-comment-wrap {
  align-items: center;
  display: flex;
  gap: 8px;
  justify-content: center;
  min-width: 0;
  width: 100%;
}

.assignments-comment-text {
  color: #475569;
  flex: 1 1 auto;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.35;
  min-width: 0;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.assignments-comment-text--empty {
  color: #94a3b8;
  font-weight: 600;
}

.assignments-comment-action {
  display: inline-flex;
  flex: 0 0 auto;
}

.assignments-comment-action ::v-deep .track-ass-btn.assign-button,
.assignments-comment-action ::v-deep .comment_btn.blue-button {
  align-items: center !important;
  background: #ffffff !important;
  border: 1px solid #dfe5ee !important;
  border-radius: 999px !important;
  box-shadow: none !important;
  color: #667085 !important;
  display: inline-flex !important;
  font-size: 0 !important;
  height: 32px !important;
  justify-content: center !important;
  line-height: 1 !important;
  margin: 0 !important;
  min-width: 32px !important;
  padding: 0 !important;
  width: 32px !important;
}

.assignments-comment-action ::v-deep .track-ass-btn.assign-button:hover,
.assignments-comment-action ::v-deep .comment_btn.blue-button:hover {
  background: #fff7ed !important;
  border-color: #fed7aa !important;
  color: var(--assign-primary-dark) !important;
}

.assignments-comment-action ::v-deep .track-ass-btn.assign-button::before {
  content: "+";
  font-size: 20px;
  font-weight: 500;
  line-height: 1;
}

.assignments-comment-action ::v-deep .comment_btn.blue-button .v-btn__content {
  align-items: center;
  color: inherit !important;
  display: inline-flex;
  font-size: 0;
  justify-content: center;
  line-height: 1;
}

.assignments-comment-action
  ::v-deep
  .comment_btn.blue-button
  .v-btn__content::before {
  content: "+";
  font-size: 20px;
  font-weight: 500;
  line-height: 1;
}

.assignments-comment-wrap {
  align-items: center;
  display: flex;
  gap: 8px;
  justify-content: center;
  min-width: 0;
  width: 100%;
}

.assignments-comment-text {
  color: #475569;
  flex: 1 1 auto;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.35;
  min-width: 0;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.assignments-comment-text--empty {
  color: #94a3b8;
  font-weight: 600;
}

.assignments-comment-action {
  display: inline-flex;
  flex: 0 0 auto;
}

.assignments-comment-action ::v-deep .track-ass-btn.assign-button,
.assignments-comment-action ::v-deep .comment_btn.blue-button {
  align-items: center !important;
  background: #ffffff !important;
  border: 1px solid #dfe5ee !important;
  border-radius: 999px !important;
  box-shadow: none !important;
  color: #667085 !important;
  display: inline-flex !important;
  font-size: 0 !important;
  height: 32px !important;
  justify-content: center !important;
  line-height: 1 !important;
  margin: 0 !important;
  min-width: 32px !important;
  padding: 0 !important;
  width: 32px !important;
}

.assignments-comment-action ::v-deep .track-ass-btn.assign-button:hover,
.assignments-comment-action ::v-deep .comment_btn.blue-button:hover {
  background: #fff7ed !important;
  border-color: #fed7aa !important;
  color: var(--assign-primary-dark) !important;
}

.assignments-comment-action ::v-deep .track-ass-btn.assign-button::before {
  content: "+";
  font-size: 20px;
  font-weight: 500;
  line-height: 1;
}

.assignments-comment-action ::v-deep .comment_btn.blue-button .v-btn__content {
  align-items: center;
  color: inherit !important;
  display: inline-flex;
  font-size: 0;
  justify-content: center;
  line-height: 1;
}

.assignments-comment-action
  ::v-deep
  .comment_btn.blue-button
  .v-btn__content::before {
  content: "+";
  font-size: 20px;
  font-weight: 500;
  line-height: 1;
}

.assignments-revamp .red-button,
.assignments-revamp .button-red {
  background: #fef2f2 !important;
  border: 1px solid #fecaca !important;
  box-shadow: none !important;
  color: #b91c1c !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.assignments-revamp .assignments-action-stack {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  justify-content: center;
  margin: 0 auto;
  width: 100%;
}

.assignments-revamp .assignments-action-stack .pay-ass-btn {
  margin-bottom: 0 !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  margin-top: 0 !important;
}

.assignments-revamp .blue-button {
  background: #eff6ff !important;
  border: 1px solid #d8ebff !important;
  box-shadow: none !important;
  color: #1d4ed8 !important;
}

.assignments-revamp .v-btn {
  border-radius: 8px !important;
  box-shadow: none !important;
  font-weight: 700 !important;
  letter-spacing: 0 !important;
  text-transform: none !important;
}

.assignments-revamp #jobsTable table.v-table tbody td .v-icon {
  color: #64748b !important;
}

.assignments-revamp #jobsTable table.v-table tbody td .v-icon:hover {
  color: var(--assign-primary-dark) !important;
}

.assignments-revamp #jobsTable table.v-table tbody td .track-assign-btn .v-icon,
.assignments-revamp #jobsTable table.v-table tbody td .assign-driver-btn .v-icon,
.assignments-revamp #jobsTable table.v-table tbody td .track-ass-btn .v-icon {
  color: #ffffff !important;
  -webkit-text-fill-color: #ffffff !important;
}

.assignments-revamp .pd_5,
.assignments-revamp .pd_8,
.assignments-revamp .pd-t-l {
  padding: 0 !important;
}

.assignments-revamp .font_Bold {
  color: #475569;
  display: block;
  font-size: 12px;
  font-weight: 800;
  margin-top: 7px;
}

.assignments-revamp .orange-text {
  color: #b45309;
}

.assignments-revamp .red-text {
  color: #b91c1c;
}

.assignments-revamp .v-alert {
  border-radius: 8px;
}

/* Final Assignment-view guards for compact scroll and comments. */
#nav .assignments-revamp--modern {
  padding: 0 !important;
}

#nav .assignments-revamp--modern .assignments-nav-grid {
  gap: 0.5rem;
  padding: 0.5rem 1.875rem !important;
}

#nav .assignments-revamp--modern .assignments-stats-grid {
  gap: 0.5rem;
  padding: 0.625rem 1.875rem !important;
}

#nav .assignments-revamp--modern .assignments-stat-card {
  min-height: 4.875rem;
  padding: 0.8125rem 0.875rem 0.75rem 3.25rem;
}

#nav .assignments-revamp--modern .assignments-stat-icon {
  height: 2rem;
  left: 0.875rem;
  top: 0.875rem;
  width: 2rem;
}

#nav .assignments-revamp--modern .assignments-filter-panel {
  margin-left: 1.875rem;
  margin-right: 1.875rem;
  padding: 0.625rem 0.75rem !important;
}

#nav
  .assignments-revamp--modern
  .assignments-filter-panel
  .oms-filter-board__field--search {
  flex: 1 1 15rem !important;
  min-width: 14rem;
}

#nav .assignments-revamp--modern .assignments-filter-panel .v-input__slot,
#nav .assignments-revamp--modern .assignments-filter-panel .e-input-group {
  height: var(--oms-filter-control-height, 2.625rem) !important;
  min-height: var(--oms-filter-control-height, 2.625rem) !important;
}

#nav .assignments-revamp--modern .assignments-table-card {
  overflow: hidden !important;
  overflow-y: visible !important;
  padding: 0 1.875rem 1.5rem !important;
}

#nav .assignments-revamp--modern .assignments-table-scroll {
  overflow-x: hidden !important;
  overflow-y: visible !important;
}

#nav
  .assignments-revamp--modern
  .assignments-table-scroll
  .v-table__overflow {
  overflow-x: auto !important;
  overflow-y: visible !important;
}

#nav .assignments-revamp--modern #jobsTable table.v-table {
  min-width: 100% !important;
  table-layout: auto !important;
  width: 100%;
}

#nav .assignments-revamp--modern #jobsTable table.v-table thead th,
#nav .assignments-revamp--modern #jobsTable table.v-table tbody td {
  box-sizing: border-box;
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
}

/* No fixed column percentages: `table-layout: auto` sizes each column to what it
   actually holds, bounded at both ends -- never narrower than 6rem, never wider
   than 15rem, past which long content wraps instead of stretching the column. */
#nav .assignments-revamp--modern #jobsTable table.v-table th,
#nav .assignments-revamp--modern #jobsTable table.v-table td {
  max-width: 15rem !important;
  min-width: 6rem !important;
  width: auto !important;
}

/* Auto layout derives a column's width from the max-content size of the cell's
   contents, so the upper bound has to sit on the content as well as the cell --
   a cap on the cell alone leaves the column free to grow. The auto margins keep
   a capped child centred; without them it sits flush left while the text above
   it centres on the cell, and the two disagree. */
#nav .assignments-revamp--modern #jobsTable table.v-table tbody td > * {
  margin-left: auto !important;
  margin-right: auto !important;
  max-width: 14rem;
  overflow-wrap: break-word;
}

#nav .assignments-revamp--modern #jobsTable table.v-table th:nth-child(12),
#nav .assignments-revamp--modern #jobsTable table.v-table td:nth-child(12),
#nav .assignments-revamp--modern #jobsTable table.v-table th:last-child,
#nav .assignments-revamp--modern #jobsTable table.v-table td:last-child {
  padding-left: 0.25rem !important;
  padding-right: 0.25rem !important;
}

#nav .assignments-revamp--modern .assignments-job-td {
  overflow: visible !important;
  padding-left: 0.375rem !important;
  padding-right: 0.375rem !important;
}

#nav .assignments-revamp--modern .assignments-job-td .layout {
  flex-wrap: nowrap !important;
  gap: 0.1875rem !important;
  justify-content: center;
}

#nav .assignments-revamp--modern .assignments-job-td .layout > div:not(.blink__icon) {
  flex: 0 0 auto;
  min-width: 1.25rem;
}

#nav .assignments-revamp--modern .assignments-job-td .v-icon {
  font-size: 0.875rem !important;
  height: 0.875rem !important;
  line-height: 0.875rem !important;
  width: 0.875rem !important;
}

#nav .assignments-revamp--modern .assignments-job-id,
#nav .assignments-revamp--modern .assignments-id-value {
  font-size: clamp(0.5625rem, 0.48vw, 0.75rem) !important;
  line-height: 1.12;
  overflow: visible !important;
  text-overflow: clip !important;
  white-space: nowrap !important;
}

#nav .assignments-revamp--modern .assignments-job-id {
  padding-left: 0 !important;
  padding-top: 0 !important;
}

#nav .assignments-revamp--modern .assignments-date-line {
  font-size: 0.625rem;
  text-align: center;
}

#nav .assignments-revamp--modern .assignments-assignment-cell {
  align-items: stretch;
  gap: 0.3125rem;
  text-align: center;
}

#nav .assignments-revamp--modern .assignments-status-pill {
  font-size: 0.625rem;
  min-width: 0;
  padding: 0.375rem 0.5rem;
  width: 100%;
}

#nav .assignments-revamp--modern #jobsTable table.v-table tbody td button,
#nav .assignments-revamp--modern #jobsTable table.v-table tbody td .v-btn,
#nav .assignments-revamp--modern #jobsTable table.v-table tbody td .oms-btn {
  max-width: 100%;
  min-width: 0 !important;
  white-space: normal !important;
}

#nav .assignments-revamp--modern .assignments-comment-cell {
  overflow: visible !important;
  padding-left: 0.375rem !important;
  padding-right: 0.375rem !important;
  position: relative;
  text-align: center !important;
}

#nav
  .assignments-revamp--modern
  .assignments-comment-cell
  .oms-comment-cell {
  gap: 0;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
  max-width: 2.5rem;
  min-height: 2rem;
  position: relative;
  width: auto;
}

#nav
  .assignments-revamp--modern
  .assignments-comment-cell
  .oms-comment-cell__text--empty {
  display: none !important;
}

#nav
  .assignments-revamp--modern
  .assignments-comment-cell
  .oms-comment-cell__text:not(.oms-comment-cell__text--empty) {
  background: var(--assign-panel);
  border: 1px solid var(--assign-border);
  border-radius: 8px;
  box-shadow: 0 0.75rem 1.75rem rgba(15, 23, 42, 0.16);
  color: var(--assign-ink);
  display: block !important;
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1.35;
  max-width: 18rem;
  min-width: 10rem;
  opacity: 0;
  padding: 0.5rem 0.625rem;
  pointer-events: none;
  position: absolute;
  right: calc(100% + 0.5rem);
  text-align: left;
  top: 50%;
  transform: translate(0.25rem, -50%);
  transition: opacity 0.15s ease, transform 0.15s ease;
  white-space: normal;
  z-index: 12;
}

#nav
  .assignments-revamp--modern
  .assignments-comment-cell:hover
  .oms-comment-cell__text:not(.oms-comment-cell__text--empty),
#nav
  .assignments-revamp--modern
  .assignments-comment-cell:focus-within
  .oms-comment-cell__text:not(.oms-comment-cell__text--empty) {
  opacity: 1;
  pointer-events: auto;
  transform: translate(0, -50%);
}

@media (max-width: 1260px) {
  .assignments-nav-grid {
    grid-template-columns: 1fr;
  }

  .assignments-nav-grid .assignments-status-tabs {
    justify-self: start;
  }

  .assignments-board-head {
    flex-direction: column;
  }

  .assignments-tab-stack {
    width: 100%;
  }

  .assignments-stats-grid,
  .assignments-filter-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 760px) {
  .assignments-revamp {
    padding: 0;
  }

  .assignments-nav-grid {
    padding: 16px;
  }

  .assignments-nav-grid .assignments-primary-tabs,
  .assignments-nav-grid .assignments-status-tabs {
    width: 100%;
  }

  .assignments-board-head,
  .assignments-stats-grid,
  .assignments-filter-grid {
    grid-template-columns: 1fr;
  }

  .assignments-board-head {
    padding: 22px 16px 14px;
  }

  .assignments-filter-panel,
  .assignments-table-card {
    margin-left: 16px;
    margin-right: 16px;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .assignments-stats-grid {
    padding-left: 16px;
    padding-right: 16px;
  }
}

#nav .assignments-revamp--modern .assignments-stats-grid {
  grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
}

#nav .assignments-revamp--modern .assignments-table-card,
#nav .assignments-revamp--modern .assignments-table-scroll,
#nav .assignments-revamp--modern #jobsTable .v-table__overflow {
  overflow-x: auto !important;
  overflow-y: visible !important;
}

#nav .assignments-revamp--modern #jobsTable table.v-table {
  min-width: var(--oms-list-table-min-width, 140rem) !important;
  width: 100%;
}

@media (max-width: 64rem) {
  #nav .assignments-revamp--modern .assignments-stats-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }
}

@media (max-width: 48rem) {
  #nav .assignments-revamp--modern .assignments-stats-grid {
    grid-template-columns: 1fr !important;
  }
}
</style>

<style scoped>
#filter-toggle {
  display: none;
}
.pd-left {
  padding-left: 5px !important;
}
.pd-t-l {
  padding-left: 5px;
  padding-top: 7px;
}
.viewDetail {
  cursor: pointer;
}
.job-detail {
  margin: auto 0;
}
.theme--light.menuable__content__active {
  min-width: 290px !important;
}
.text-center {
  text-align: center !important;
}

.date-picker {
  min-width: 100%;
}

.page-count-span {
  float: right;
  margin-top: 26px;
  color: darkorange;
}
.cancel-btn {
  text-decoration: none;
  color: #ffffff;
  border: 2px solid red;
  padding: 2px;
  margin-top: 5px;
  background-color: #f38282;
  border-radius: 5px;
}
.view-ass-btn {
  text-decoration: none;
  color: #ffffff;
  background-color: #c87ffe;
  border: 2px solid indigo;
  padding: 2px 5px;
  border-radius: 5px;
}
.assign-driver-btn {
  text-decoration: none;
  color: #ffffff;
  background-color: #bebebe;
  border: 2px solid grey;
  padding: 2px 5px;
  border-radius: 5px;
}

.p-16 {
  padding: 0 16px !important;
}
.p-b-0 {
  padding-bottom: 0 !important;
}
.p-t-0 {
  padding-top: 0 !important;
}
.minHeight {
  min-height: 300px;
}
.colorchange {
  background-color: #fae3e3 !important;
}
.colorchangeyellow {
  background-color: #ffffe0 !important;
}
.spacerclass {
  max-height: 550px !important;
}
.m-t-10 {
  margin-top: 10px;
}

.filter {
  padding: 20px;
  margin: 0 auto;
}
.reset {
  margin-top: 10px;
}
.button-red {
  background-color: #ff7b7b !important;
  color: #ffffff !important;
  border: 2px solid red !important;
  margin-top: 5px !important;
  margin-left: 0 !important;
}
.font_Bold {
  font-size: 13px;
  font-weight: 600;
  margin-top: 2px;
  font-family: "Open Sans bold", sans-serif;
}
.orange-text {
  color: orange;
}
.red-text {
  color: red;

  animation: animate 1.5s linear infinite;
}

@keyframes animate {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 0.6;
  }

  100% {
    opacity: 0;
  }
}
</style>
